function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var WebReporter$1 = {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

var tslib_es6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	__extends: __extends,
	get __assign () { return __assign; },
	__rest: __rest,
	__decorate: __decorate,
	__param: __param,
	__metadata: __metadata,
	__awaiter: __awaiter,
	__generator: __generator,
	__createBinding: __createBinding,
	__exportStar: __exportStar,
	__values: __values,
	__read: __read,
	__spread: __spread,
	__spreadArrays: __spreadArrays,
	__spreadArray: __spreadArray,
	__await: __await,
	__asyncGenerator: __asyncGenerator,
	__asyncDelegator: __asyncDelegator,
	__asyncValues: __asyncValues,
	__makeTemplateObject: __makeTemplateObject,
	__importStar: __importStar,
	__importDefault: __importDefault,
	__classPrivateFieldGet: __classPrivateFieldGet,
	__classPrivateFieldSet: __classPrivateFieldSet
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

var base64 = {exports: {}};

/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */

(function (module, exports) {
(function(root) {

	// Detect free variables `exports`.
	var freeExports = exports;

	// Detect free variable `module`.
	var freeModule = module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));
}(base64, base64.exports));

var utf8 = {};

/*! https://mths.be/utf8js v3.0.0 by @mathias */

(function (exports) {
(function(root) {

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	root.version = '3.0.0';
	root.encode = utf8encode;
	root.decode = utf8decode;

}(exports));
}(utf8));

var Reporter$1 = {};

var validateBoolean$1 = {};

Object.defineProperty(validateBoolean$1, "__esModule", { value: true });
validateBoolean$1.validateBoolean = void 0;
// 验证方法的参数为布尔类型
var validateBoolean = function (val, methodString) {
    if (typeof val !== 'boolean') {
        throw Error("sdk error: " + methodString + " only accept argument of a type of Boolean!");
    }
    return true;
};
validateBoolean$1.validateBoolean = validateBoolean;

var validateDeviceId$1 = {};

Object.defineProperty(validateDeviceId$1, "__esModule", { value: true });
validateDeviceId$1.validateDeviceId = void 0;
// 验证setDeviceKey(deviceId)方法的参数
var validateDeviceId = function (id) {
    if (typeof id !== 'string' && typeof id !== 'number') {
        throw Error('sdk error: _dw.setDeviceKey(deviceId) call error, deviceId should be type of String or Number');
    }
    return true;
};
validateDeviceId$1.validateDeviceId = validateDeviceId;

var validateString$1 = {};

Object.defineProperty(validateString$1, "__esModule", { value: true });
validateString$1.validateString = void 0;
// 验证方法的参数为字符串类型
var validateString = function (val, methodString) {
    if (typeof val !== 'string') {
        throw Error("sdk error: " + methodString + " only accept argument of a type of String!");
    }
    return true;
};
validateString$1.validateString = validateString;

var DWConfig$1 = {};

var copy$1 = {};

Object.defineProperty(copy$1, "__esModule", { value: true });
copy$1.copy = void 0;
/**
   * 复制
   * @param from 要复制的对象
   * @returns
   */
function copy(from) {
    // 只能复制不带function的
    return JSON.parse(JSON.stringify(from));
}
copy$1.copy = copy;

// 配置器, 源自 src/config.js
Object.defineProperty(DWConfig$1, "__esModule", { value: true });
DWConfig$1.DWConfig = void 0;
var copy_1 = copy$1;
var DWConfig = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function DWConfig(Reporter) {
        this.Reporter = Reporter;
        this.data = this.generateDefaultConfig();
    }
    /**
     * 生成一份默认配置
     * @description 这个被实例化是在配置 Reporter.adapter.osInfo 之后, 所以弄成一个方法
     * @returns
     */
    DWConfig.prototype.generateDefaultConfig = function () {
        var defaults = this.Reporter.defaults;
        return {
            protocol: 11,
            st: 'js',
            sv: "3.0.27",
            accountId: '',
            deviceId: '',
            appKey: defaults.appKey || '',
            channel: 'default_channel',
            version: defaults.appVersion || 'default_version',
            dbg: defaults.debugMode || false,
            dbgUrl: '',
            customPublicAttrs: {},
            customPV: defaults.customPV || false,
            defaultEvents: true,
            noEncrypted: defaults.noEncrypted || false // 不进行加密
        };
    };
    /** 校验 key 是否合法 */
    DWConfig.prototype.validateKey = function (key) {
        if (typeof key !== 'string') {
            throw Error('[dw error] config key should be string.');
        }
        if (!(key in this.data)) {
            throw Error("[dw error] the key '" + key + " is invalid.'");
        }
    };
    /**
     * 设置一个 config
     * @param key 键
     * @param value 值
     * @param storage 存储器
     */
    DWConfig.prototype.set = function (key, value) {
        this.validateKey(key);
        this.data[key] = value;
    };
    /**
     * 获取一个 config
     * @param key 键
     * @returns
     */
    DWConfig.prototype.get = function (key) {
        this.validateKey(key);
        return this.data[key];
    };
    /** 获取所有 config */
    DWConfig.prototype.getAll = function () {
        return copy_1.copy(this.data);
    };
    /**
     * 设置用户配置
     * @param key 用户配置的键
     * @param value 对应的值
     */
    DWConfig.prototype.setCustomPublicAttrs = function (key, value) {
        this.data.customPublicAttrs[key] = value;
    };
    return DWConfig;
}());
DWConfig$1.DWConfig = DWConfig;

var DWEvent$1 = {};

var DWRequest$1 = {};

Object.defineProperty(DWRequest$1, "__esModule", { value: true });
DWRequest$1.DWRequest = void 0;
var DWRequest = /** @class */ (function () {
    function DWRequest() {
    }
    DWRequest.prototype.stopPost = function () {
        this.stopped = true;
        return this;
    };
    DWRequest.prototype.cancelStopPost = function () {
        this.stopped = false;
        return this;
    };
    DWRequest.prototype.isPostStopped = function () {
        return this.stopped;
    };
    return DWRequest;
}());
DWRequest$1.DWRequest = DWRequest;

var dateFormat$1 = {};

Object.defineProperty(dateFormat$1, "__esModule", { value: true });
dateFormat$1.dateFormat = void 0;
/**
   * 获取当前时间
   * @returns
   */
function dateFormat(currentDate) {
    // 格式化函数
    var double = function (time) { return time < 10 ? '0' + time : time; };
    // 中国时间
    var today = currentDate;
    // yyyy-MM-dd
    var year = today.getFullYear();
    var month = today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1;
    var date = double(today.getDate());
    var YTD = [year, month, date].join('-');
    // HH.mm:ss.mms
    var hours = double(today.getHours());
    var minutes = double(today.getMinutes());
    var seconds = double(today.getSeconds());
    var tempMS = today.getMilliseconds().toString();
    var milliSecondes = tempMS.length < 3 ? '000'.slice(0, 3 - tempMS.length) + tempMS : tempMS;
    var HMSM = [hours, minutes, seconds].join(':') + '.' + milliSecondes;
    var TIMEZONE = '+0800'; // 固定时区
    return [YTD, HMSM, TIMEZONE].join(' ');
}
dateFormat$1.dateFormat = dateFormat;

var generateGuid$1 = {};

Object.defineProperty(generateGuid$1, "__esModule", { value: true });
generateGuid$1.generateGuid = void 0;
/**
   * 随机生成一个无序ID
   * @returns
   */
function generateGuid() {
    var s4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}
generateGuid$1.generateGuid = generateGuid;

var getSessionId$1 = {};

Object.defineProperty(getSessionId$1, "__esModule", { value: true });
getSessionId$1.getSessionId = void 0;
/**
   * 获取sessionId
   */
function getSessionId() {
    try {
        if (typeof document !== 'undefined' && typeof document.cookie === 'string') {
            return /SESS\w*ID=([^;]+)/i.test(document.cookie) ? RegExp.$1 : '';
        }
    }
    catch (e) { }
    return '';
}
getSessionId$1.getSessionId = getSessionId;

var DWProcess$1 = {};

function mitt_es(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i&&i.push(e)||n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&i.splice(i.indexOf(e)>>>0,1);},emit:function(t,e){(n.get(t)||[]).slice().map(function(n){n(e);}),(n.get("*")||[]).slice().map(function(n){n(t,e);});}}}

var mitt_es$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': mitt_es
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(mitt_es$1);

var DWDynamic$1 = {};

var typings$1 = {};

(function (exports) {
/* eslint-disable no-unused-vars */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Http = void 0;
(function (Http) {
    (function (Type) {
        Type["GET"] = "GET";
        Type["POST"] = "POST";
        Type["JSONP"] = "jsonp";
    })(Http.Type || (Http.Type = {}));
})(exports.Http || (exports.Http = {}));
}(typings$1));

Object.defineProperty(DWDynamic$1, "__esModule", { value: true });
DWDynamic$1.DWDynamic = void 0;
var tslib_1$8 = require$$0$1;
var typings_1$3 = typings$1;
var DWRequest_1$1 = DWRequest$1;
var DWDynamic = /** @class */ (function (_super) {
    tslib_1$8.__extends(DWDynamic, _super);
    function DWDynamic(dwProcess) {
        var _this = _super.call(this) || this;
        _this.dwProcess = dwProcess;
        _this.retryCount = 0;
        _this.appKeyCount = 0;
        _this.redirectCount = 0;
        return _this;
    }
    /**
     * 读取本地缓存
     */
    DWDynamic.prototype.read = function () {
        this.local = this.dwProcess.dwStorage.readDynamicData();
        return this;
    };
    DWDynamic.prototype.save = function (data) {
        return this.dwProcess.dwStorage.saveDynamicData(data);
    };
    /**
     * 移除本地动参
     * @returns Promise<void>
     */
    DWDynamic.prototype.remove = function () {
        this.local = null;
        return this.dwProcess.dwStorage.removeDynamicData();
    };
    /**
     * 检测本地动参是否过期
     * @returns Promise<boolean>
     */
    DWDynamic.prototype.checkExpire = function () {
        return tslib_1$8.__awaiter(this, void 0, void 0, function () {
            var dynamicLocalData, currentDate, localTimeDifference, localDate, serverDate;
            return tslib_1$8.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.local) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.local];
                    case 1:
                        dynamicLocalData = _a.sent();
                        if (!dynamicLocalData) {
                            return [2 /*return*/, true];
                        }
                        if (!dynamicLocalData.serverTime) {
                            return [2 /*return*/, true];
                        }
                        currentDate = this.dwProcess.getRemoteDate();
                        if (!!currentDate) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dwProcess.dwStorage.readTimeDifference()];
                    case 2:
                        localTimeDifference = _a.sent();
                        if (localTimeDifference) {
                            this.dwProcess.timeDifference = localTimeDifference;
                        }
                        else {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3:
                        localDate = new Date(dynamicLocalData.serverTime);
                        serverDate = currentDate !== null && currentDate !== void 0 ? currentDate : this.dwProcess.getRemoteDate();
                        return [2 /*return*/, localDate.toLocaleDateString() !== serverDate.toLocaleDateString()];
                }
            });
        });
    };
    /**
     * 生成动态参数请求的请求体
     * @param config 全部配置
     * @param dynamicData 动态参数数据
     * @returns
     */
    DWDynamic.prototype.generateRequestBody = function (config, dynamicData) {
        var _a, _b, _c, _d, _e, _f;
        if (config === void 0) { config = {}; }
        return tslib_1$8.__awaiter(this, void 0, void 0, function () {
            return tslib_1$8.__generator(this, function (_g) {
                // const { osInfo } = this.dwProcess.Reporter.adapters
                return [2 /*return*/, {
                        appVersion: config.version,
                        // channel: config.channel || await osInfo.getPlatform(),
                        // countryCode: await osInfo.getCountryCode(),
                        // brand: await osInfo.getBrand(),
                        // model: await osInfo.getModel(),
                        // os: await osInfo.getOs(),
                        // osVersion: await osInfo.getOsVer(),
                        // netType: await osInfo.getNetwork(),
                        // gid: await this.dwProcess.dwStorage.readDeviceId(config.appKey, this.dwProcess.dwConfig),
                        // carrier: await osInfo.getCarrier(),
                        // screenSize: await osInfo.getScreen(),
                        // point: config.getUserLocation ? await osInfo.getGps() : '',
                        sendUrlVersion: (_b = (_a = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.sendUrls) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : 0,
                        transportControlVersion: (_d = (_c = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.uploadStrategy) === null || _c === void 0 ? void 0 : _c.version) !== null && _d !== void 0 ? _d : 0,
                        eventsVersion: (_f = (_e = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.events) === null || _e === void 0 ? void 0 : _e.version) !== null && _f !== void 0 ? _f : 0,
                        // abTestVersion: dynamicData?.abTestTag?.version ?? 0,
                        abTestName: '',
                        abTestGroupId: ''
                    }];
            });
        });
    };
    DWDynamic.prototype.body = function () {
        var _this = this;
        var dwConfig = this.dwProcess.dwConfig;
        if (this.local) {
            this.requestBody = this.local.then(function (data) {
                return _this.generateRequestBody(dwConfig.getAll(), data !== null && data !== void 0 ? data : {});
            });
        }
        else {
            this.requestBody = this.generateRequestBody(dwConfig.getAll());
        }
        return this;
    };
    /**
     * 终点: 发送请求(内含结果处理, 保存)
     * @description dwDynamic.read().post() 读取本地缓存后会优先使用缓存中的地址
     * @param url 发送地址
     */
    DWDynamic.prototype.post = function (url) {
        return tslib_1$8.__awaiter(this, void 0, void 0, function () {
            var appKey, _a, defaults, fixed, localData, requestBody, requestUrl;
            var _this = this;
            return tslib_1$8.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.requestBody) {
                            console.error('[dw-js-sdk] dwDynamic.body() needs to be invoked');
                            return [2 /*return*/];
                        }
                        if (this.isPostStopped()) {
                            return [2 /*return*/];
                        }
                        appKey = this.dwProcess.dwConfig.get('appKey');
                        // 检查是否有appKey, 如果没有获取到到. 延迟500ms再进行获取. 最多获取60次
                        if (!appKey) {
                            if (this.appKeyCount < parseInt("60")) {
                                this.appKeyCount++;
                                this.retry();
                            }
                            else {
                                // 如果已经获取了60次appKey， 抛出错误
                                console.error('[dw-js-sdk] appKey not be detected, please set the appKey by "dw.setAppKey()"!');
                            }
                            return [2 /*return*/];
                        }
                        if (!(this.retryCount >= parseInt("15") ||
                            this.redirectCount >= parseInt("10"))) return [3 /*break*/, 2];
                        // 若果已经重定向过，也是失败，可能重定向地址错误，回到默认地址（移除本地动参存储），下次刷新后重新开始
                        return [4 /*yield*/, this.stopRetry().remove()];
                    case 1:
                        // 若果已经重定向过，也是失败，可能重定向地址错误，回到默认地址（移除本地动参存储），下次刷新后重新开始
                        _b.sent();
                        console.error('[dw-js-sdk] requestDynamic failed for max connect count!');
                        return [2 /*return*/];
                    case 2:
                        if (!url) return [3 /*break*/, 3];
                        this.url = url;
                        return [3 /*break*/, 7];
                    case 3:
                        _a = this.dwProcess.Reporter, defaults = _a.defaults, fixed = _a.fixed;
                        if (!fixed.dynamicUrl) return [3 /*break*/, 4];
                        this.url = fixed.dynamicUrl;
                        return [3 /*break*/, 7];
                    case 4:
                        if (!this.local) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.local];
                    case 5:
                        localData = _b.sent();
                        if (localData && localData.dynamicUrl) {
                            this.url = localData.dynamicUrl;
                        }
                        else {
                            this.url = defaults.dynamicUrl;
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        this.url = defaults.dynamicUrl;
                        _b.label = 7;
                    case 7:
                        // 发送前事件处理
                        this.dwProcess.emit('before-dynamic-send', {
                            dwDynamic: this,
                            dwProcess: this.dwProcess
                        });
                        // 是否停止发送
                        if (this.isPostStopped()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.requestBody];
                    case 8:
                        requestBody = _b.sent();
                        requestUrl = this.url + "/api/dynamicParam/v1/app/" + appKey;
                        // this.requestBody 里没有事件, 暂时去掉
                        // if (this.isPostStopped()) {
                        //   return
                        // }
                        // 发送请求动态
                        this.dwProcess.Reporter.adapters.http.send(requestUrl, {
                            type: typings_1$3.Http.Type.JSONP,
                            timeout: parseInt("3000"),
                            data: requestBody
                        }, function (err, data) { return tslib_1$8.__awaiter(_this, void 0, void 0, function () {
                            var emit;
                            var _this = this;
                            return tslib_1$8.__generator(this, function (_a) {
                                emit = function (data) {
                                    _this.dwProcess.emit('after-dynamic-send', {
                                        dwDynamic: _this,
                                        dwProcess: _this.dwProcess,
                                        dynamicData: data
                                    });
                                };
                                // 判断是否有err(请求超时的情况)和返回值是否有数据, 如果是的话重新动参
                                if (err || !data) {
                                    this.retryCount++;
                                    this.retry(this.url);
                                    emit();
                                    return [2 /*return*/];
                                }
                                // 返回字符串，url重定向
                                if (typeof data === 'object' && Object.keys(data).length === 1 && data.dynamicUrl) {
                                    this.redirectCount++;
                                    this.retry(data.dynamicUrl, 0);
                                    emit();
                                    return [2 /*return*/];
                                }
                                this.data = Promise.resolve(data);
                                this
                                    .stopRetry()
                                    .mergeLocal(data)
                                    .handleData()
                                    .data.then(emit);
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    DWDynamic.prototype.retry = function (url, interval) {
        var _this = this;
        if (interval === void 0) { interval = parseInt("1000"); }
        this.stopRetry();
        this.retryTimer = setTimeout(function () {
            _this.cancelStopPost();
            _this.post(url);
        }, interval);
        return this;
    };
    DWDynamic.prototype.stopRetry = function () {
        clearTimeout(this.retryTimer);
        return this;
    };
    DWDynamic.prototype.handleData = function (fromLocal) {
        var _this = this;
        var dwProcess = this.dwProcess;
        if (!this.data) {
            console.error('[dw-js-sdk] dynamic data is not resolved');
            return this;
        }
        this.data = this.data.then(function (data) { return tslib_1$8.__awaiter(_this, void 0, void 0, function () {
            return tslib_1$8.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data) {
                            console.error('[dw-js-sdk] dynamic data resolved is null');
                            return [2 /*return*/, data];
                        }
                        if (!!fromLocal) return [3 /*break*/, 2];
                        // localTime 是动参返回时的本地时间, 一起保存
                        data.localTime = Date.now();
                        return [4 /*yield*/, this.save(data)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // 保存服务器和本地时间时间差到 localStorage 中
                        // 如果是本地的, 则不保存
                        if (data.serverTime) {
                            if (data.localTime) {
                                dwProcess.timeDifference = data.serverTime - data.localTime;
                                dwProcess.dwStorage.saveTimeDifference(dwProcess.timeDifference);
                            }
                            else {
                                // 没有保存 localTime 时 (v3.0.12 之前的版本), 使用本地时间
                                dwProcess.dwStorage.readTimeDifference().then(function (timeDifference) {
                                    dwProcess.timeDifference = timeDifference !== null && timeDifference !== void 0 ? timeDifference : 0;
                                });
                            }
                        }
                        return [2 /*return*/, data];
                }
            });
        }); });
        return this;
    };
    /**
     * 将返回的数据和本地数据合并
     * @param data 返回的数据
     */
    DWDynamic.prototype.mergeLocal = function (data) {
        this.data = this.local
            ? this.local.then(function (local) {
                if (!local) {
                    return data;
                }
                else {
                    var mergeData = {};
                    try {
                        // 只把 data 有的键值从 local 合并
                        for (var key in data) {
                            var name_1 = key;
                            var item = data[name_1];
                            if (Object.prototype.toString.call(item) !== '[object Object]') {
                                mergeData[name_1] = item;
                            }
                            else {
                                mergeData[name_1] = Object.assign({}, local[name_1], item);
                            }
                        }
                    }
                    catch (e) { }
                    return mergeData;
                }
            })
            : Promise.resolve(data);
        return this;
    };
    /**
     * 使用本地数据
     */
    DWDynamic.prototype.useLocal = function () {
        var _this = this;
        var dwProcess = this.dwProcess;
        this.data = this.local.then(function (data) { return data; });
        this.handleData(true);
        this.data.then(function (data) {
            // 就当它发送成功了, 不然 useLocal 再一大堆和发送成功一样的逻辑
            dwProcess.emit('after-dynamic-send', {
                dwDynamic: _this,
                dwProcess: dwProcess,
                dynamicData: data
            });
        });
        return this;
    };
    return DWDynamic;
}(DWRequest_1$1.DWRequest));
DWDynamic$1.DWDynamic = DWDynamic;

// 业务进程, 源自 src/init.js 和 src/event.js, 用于串联所有工具类
Object.defineProperty(DWProcess$1, "__esModule", { value: true });
DWProcess$1.DWProcess = void 0;
var tslib_1$7 = require$$0$1;
var mitt_1 = tslib_1$7.__importDefault(require$$1);
var DWDynamic_1 = DWDynamic$1;
var DWEvent_1$3 = DWEvent$1;
var DWProcess = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function DWProcess(Reporter, dwConfig, dwStorage, dwService) {
        this.Reporter = Reporter;
        this.dwConfig = dwConfig;
        this.dwStorage = dwStorage;
        this.dwService = dwService;
        this.state = 'prepare';
        this.cache = {
            appEndExtraEvents: [],
            defaultEventsData: {},
            others: {}
        };
        this.dwDynamic = new DWDynamic_1.DWDynamic(this);
        /** 事件处理器 */
        this.eventBus = mitt_1.default();
        DWProcess.instances.push(this);
    }
    DWProcess.prototype.getRemoteDate = function (localDate) {
        if (localDate === void 0) { localDate = new Date(); }
        if (this.timeDifference == null) {
            return;
        }
        // 本地时间
        var localTime = localDate.getTime();
        var timeDifference = this.timeDifference;
        var localTimeDifference = localTime + timeDifference; // 本地时间校准
        // 转中国时间
        var localTimeOffset = new Date().getTimezoneOffset() * 60 * 1000; // 毫秒
        var result = new Date();
        result.setTime(localTimeDifference + localTimeOffset + 8 * 60 * 60 * 1000);
        return result;
    };
    // public sendErrorReport <T extends (...args: any) => any> (
    //   work: T,
    //   mixinMessage: DW.Event.Error = {},
    //   catchCallback?: T
    // ): ReturnType<T> | void {
    //   try {
    //     return work()
    //   } catch (e) {
    //     if (this.errorCount > 0) {
    //       const reportData = Object.assign({
    //         excpt_key: 'dw error',
    //         excpt_stack: JSON.stringify(e),
    //         errorCount: this.errorCount
    //       }, mixinMessage)
    //       new DWEvent('_exception_log', reportData, this).post()
    //       console.error(reportData)
    //       this.errorCount--
    //     }
    //     if (catchCallback) {
    //       return catchCallback(e)
    //     }
    //   }
    // }
    DWProcess.prototype.sendPageView = function () {
        var osInfo = this.Reporter.adapters.osInfo;
        var defaultEventsData = this.cache.defaultEventsData;
        var dwEvent = new DWEvent_1$3.DWEvent('_page_view', tslib_1$7.__assign(tslib_1$7.__assign(tslib_1$7.__assign({}, defaultEventsData.common), defaultEventsData._page_view), { title: osInfo.getTitle(), url: osInfo.getUrl(), refer: osInfo.getReferer() }), this);
        DWProcess.printLog('Process', 'sendPageView', '', dwEvent);
        return dwEvent.post();
    };
    DWProcess.prototype.sendAppStart = function (extraData) {
        if (extraData === void 0) { extraData = {}; }
        return tslib_1$7.__awaiter(this, void 0, void 0, function () {
            var firstVisit, defaultEventsData, dwEvent;
            return tslib_1$7.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dwStorage.readIsFirstVisit()];
                    case 1:
                        firstVisit = _a.sent();
                        defaultEventsData = this.cache.defaultEventsData;
                        if (firstVisit) {
                            this.dwStorage.saveVisitAlready();
                        }
                        dwEvent = new DWEvent_1$3.DWEvent('_app_start', tslib_1$7.__assign(tslib_1$7.__assign(tslib_1$7.__assign(tslib_1$7.__assign({}, defaultEventsData.common), defaultEventsData._app_start), { is_first_time: firstVisit.toString(), start_type: this.hotLaunch ? '2' : '1', resume_from_background: 'false' }), extraData), this);
                        // 小程序的 appStart 会调用多次, 避免重复设置 startDate
                        if (!this.startDate) {
                            this.startDate = new Date();
                        }
                        return [2 /*return*/, dwEvent.post()];
                }
            });
        });
    };
    /**
     * 生成 _app_end 事件发送时的所有 _events
     */
    DWProcess.prototype.generateAppEndEvent = function (extraData) {
        var _this = this;
        if (extraData === void 0) { extraData = {}; }
        // const { dwStorage } = this
        var combineEvents = [];
        var defaultEventsData = this.cache.defaultEventsData;
        // 更新事件的时间
        this.cache.appEndExtraEvents.forEach(function (extraEvent) {
            extraEvent.localDate = new Date();
            extraEvent.remoteDate = _this.getRemoteDate(extraEvent.localDate);
        });
        // 读取通过 setAppEndExtraData 方法设置的事件
        combineEvents.push.apply(combineEvents, tslib_1$7.__spreadArray([], tslib_1$7.__read(this.cache.appEndExtraEvents)));
        // 2021.11.25 发送时不读取内存事件
        // TODO 做分片处理
        // // 读取内存中的事件
        // combineEvents.push(...dwStorage.cache.read())
        // combineEvents.push(...dwStorage.wait.read())
        // combineEvents.push(...dwStorage.fail.read())
        // // 将内存中的事件直接同步到本地
        // dwStorage.cache.sync()
        // dwStorage.wait.sync()
        // dwStorage.fail.sync()
        // // 重置内存中的事件
        // dwStorage.cache.reset()
        // dwStorage.wait.reset()
        // dwStorage.fail.reset()
        // 组合事件体
        var dwEvent = new DWEvent_1$3.DWEvent('_app_end', tslib_1$7.__assign(tslib_1$7.__assign(tslib_1$7.__assign(tslib_1$7.__assign({}, defaultEventsData.common), defaultEventsData._app_end), { use_duration: this.startDate ? Date.now() - this.startDate.getTime() : 0 }), extraData), this, null, combineEvents).body();
        return dwEvent;
    };
    /**
     * @param extraData
     */
    DWProcess.prototype.sendAppEnd = function (extraData) {
        if (extraData === void 0) { extraData = {}; }
        var dwEvent = this.generateAppEndEvent(extraData);
        this.hotLaunch = true;
        return dwEvent.post();
    };
    DWProcess.prototype.prepare = function () {
        return tslib_1$7.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1$7.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.state = 'prepare';
                        DWProcess.printLog('Process', 'prepare', 'preparing');
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve); })
                            // 获取 osInfo
                        ];
                    case 1:
                        _b.sent();
                        // 获取 osInfo
                        return [4 /*yield*/, this.Reporter.adapters.osInfo.getInfo()
                            // console.log(1111, await this.Reporter.adapters.osInfo.getInfo({
                            //   ua: 'Mozilla/5.0 (Linux; Android 10; MIX 2S Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36 android-woa/2.32.0 (inner001) device_id/e03a5ab5b93457349d1b159837c93354 appIsPhone'
                            // }))
                            // 获取 deviceId
                        ];
                    case 2:
                        // 获取 osInfo
                        _b.sent();
                        // console.log(1111, await this.Reporter.adapters.osInfo.getInfo({
                        //   ua: 'Mozilla/5.0 (Linux; Android 10; MIX 2S Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36 android-woa/2.32.0 (inner001) device_id/e03a5ab5b93457349d1b159837c93354 appIsPhone'
                        // }))
                        // 获取 deviceId
                        _a = this.cache;
                        return [4 /*yield*/, this.dwStorage.readDeviceId(this.dwConfig.get('appKey'), this.dwConfig)
                            // 读取本地事件
                        ];
                    case 3:
                        // console.log(1111, await this.Reporter.adapters.osInfo.getInfo({
                        //   ua: 'Mozilla/5.0 (Linux; Android 10; MIX 2S Build/QKQ1.190828.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36 android-woa/2.32.0 (inner001) device_id/e03a5ab5b93457349d1b159837c93354 appIsPhone'
                        // }))
                        // 获取 deviceId
                        _a.deviceId = _b.sent();
                        // 读取本地事件
                        return [4 /*yield*/, this.dwStorage.readEvents(this)];
                    case 4:
                        // 读取本地事件
                        _b.sent();
                        DWProcess.printLog('Process', 'prepare', 'prepare done');
                        this.state = 'normal';
                        return [2 /*return*/];
                }
            });
        });
    };
    DWProcess.prototype.refresh = function (isForceRefresh) {
        var _a;
        return tslib_1$7.__awaiter(this, void 0, void 0, function () {
            var currentDate, shouldSendAppEnd;
            return tslib_1$7.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.state = 'prepare';
                        this.emit('before-refresh', {
                            dwProcess: this
                        });
                        currentDate = (_a = this.getRemoteDate()) !== null && _a !== void 0 ? _a : new Date();
                        shouldSendAppEnd = (this.startDate && currentDate.toDateString() !== this.startDate.toDateString()) || isForceRefresh;
                        if (!(this.dwConfig.get('defaultEvents') && shouldSendAppEnd)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sendAppEnd()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.init({ fresh: true, isForceRefresh: isForceRefresh })];
                    case 3:
                        _b.sent();
                        DWProcess.printLog('Process', 'refresh', '', { currentDate: currentDate, startDate: this.startDate }, true);
                        this.state = 'normal';
                        return [2 /*return*/];
                }
            });
        });
    };
    DWProcess.prototype.init = function (options) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        return tslib_1$7.__awaiter(this, void 0, void 0, function () {
            var send, currentDate, timer_1, hasExpired;
            var _this = this;
            return tslib_1$7.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.state = 'prepare';
                        DWProcess.printLog('Process', 'init');
                        if (!this.dwConfig.get('defaultEvents')) return [3 /*break*/, 6];
                        send = function () { return tslib_1$7.__awaiter(_this, void 0, void 0, function () {
                            var tasks;
                            return tslib_1$7.__generator(this, function (_a) {
                                tasks = [];
                                tasks.push(this.sendAppStart());
                                if (!this.dwConfig.get('customPV')) {
                                    tasks.push(this.sendPageView());
                                }
                                DWProcess.printLog('Process', 'init', 'sending defaultEvent', tasks);
                                return [2 /*return*/, Promise.all(tasks)];
                            });
                        }); };
                        if (!((options.fresh && this.startDate) || options.isForceRefresh)) return [3 /*break*/, 3];
                        currentDate = (_a = this.getRemoteDate()) !== null && _a !== void 0 ? _a : new Date();
                        DWProcess.printLog('Process', 'init', 'fresh', { startDate: this.startDate, currentDate: currentDate, isForceRefresh: options.isForceRefresh });
                        if (!(currentDate.toDateString() !== this.startDate.toDateString() || options.isForceRefresh)) return [3 /*break*/, 2];
                        // 刷新时, 不是同一天, 可以发送
                        this.startDate = null;
                        this.hotLaunch = false;
                        return [4 /*yield*/, send()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, send()];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        (_b = this.Reporter.defaults) === null || _b === void 0 ? void 0 : _b.handleAppEnd(this, options);
                        _c.label = 6;
                    case 6:
                        // 设置全局回调函数
                        if (!options.fresh) {
                            // 注册 dynamic 请求结束事件
                            this.on('after-dynamic-send', function (event) {
                                // 发送成功
                                if (event.dynamicData) {
                                    _this.dynamicData = event.dynamicData;
                                    _this.state = 'normal';
                                    // 等待缓存事件存储到本地 (因为存储到本地有防抖, 所以没用了)
                                    // setTimeout(() => this.sendAllStorages(), parseInt("100") + 100)
                                    DWProcess.printLog('Process', 'init', 'sending allStorages');
                                    _this.sendAllStorages();
                                }
                            });
                            // 注册 onEvent 请求结束事件
                            this.on('after-event-send', function (event) {
                                // 发送成功
                                if ((event === null || event === void 0 ? void 0 : event.response) && !event.response.error) {
                                    clearTimeout(timer_1);
                                    timer_1 = setTimeout(function () {
                                        DWProcess.instances.forEach(function (dwProcess) { return dwProcess.sendAllStorages(); });
                                    }, 800);
                                }
                            });
                        }
                        _c.label = 7;
                    case 7:
                        _c.trys.push([7, 11, , 13]);
                        if (!this.dwConfig.get('dbg')) return [3 /*break*/, 8];
                        this.dwDynamic.read().body().post();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, (this.dwDynamic.read().checkExpire())];
                    case 9:
                        hasExpired = _c.sent();
                        if (hasExpired) {
                            DWProcess.printLog('Process', 'init', 'getting dwDynamic');
                            this.dwDynamic.body().post(); // post 和 useLocal 不能 await
                        }
                        else {
                            this.dwDynamic.useLocal(); // post 和 useLocal 不能 await
                        }
                        _c.label = 10;
                    case 10: return [3 /*break*/, 13];
                    case 11:
                        _c.sent();
                        return [4 /*yield*/, this.dwDynamic.remove()];
                    case 12:
                        _c.sent();
                        this.dwDynamic.body().retry();
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    DWProcess.prototype.sendAllStorages = function () {
        // 上报等待事件
        this.dwService.sendWaitEvents(this);
        // 上报缓存事件
        this.dwService.sendCacheEvents(this);
        // 上报失败事件
        this.dwService.sendFailEvents(this);
    };
    DWProcess.printLog = function (module, func, extraInfo, data, isKeyNode, debugMode) {
        if (extraInfo === void 0) { extraInfo = ''; }
        try {
            // @ts-ignore
            if ((globalThis === null || globalThis === void 0 ? void 0 : globalThis.dw_print_debug_log) || debugMode) {
                // let formatData = data
                // if (typeof data === 'object' && format) {
                //   try {
                //     formatData = JSON.stringify(formatData, null, 2)
                //   } catch (e) {
                //   }
                // }
                console.log("%c js-sdk-" + "3.0.27" + " %c " + module + "-" + func + " %c " + (extraInfo || '') + "%c ", 'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff', "background: " + (isKeyNode ? '#e5447a' : '#41b883') + " ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff", 'background:transparent; font-weight: bolder', 'font-weight: normal', data || '');
            }
        }
        catch (error) {
        }
    };
    DWProcess.prototype.isDebug = function () {
        return this.dwConfig.get('dbg');
    };
    DWProcess.prototype.on = function (name, callback) {
        this.eventBus.on(name, callback);
        return this;
    };
    DWProcess.prototype.off = function (name, callback) {
        this.eventBus.off(name, callback);
        return this;
    };
    DWProcess.prototype.emit = function (name, event) {
        this.eventBus.emit(name, event);
        return this;
    };
    DWProcess.instances = [];
    return DWProcess;
}());
DWProcess$1.DWProcess = DWProcess;

// 事件类
Object.defineProperty(DWEvent$1, "__esModule", { value: true });
DWEvent$1.DWEvent = void 0;
var tslib_1$6 = require$$0$1;
var DWRequest_1 = DWRequest$1;
var dateFormat_1 = dateFormat$1;
var generateGuid_1$1 = generateGuid$1;
var getSessionId_1 = getSessionId$1;
var DWProcess_1$4 = DWProcess$1;
var DWEvent = /** @class */ (function (_super) {
    tslib_1$6.__extends(DWEvent, _super);
    function DWEvent(
    /** 事件名 */
    name, 
    /** 事件内容 (可为 null, 没有时表示从 sendWait 来的) */
    data, 
    /** 进程中间件 */
    dwProcess, 
    /** 本地读取内容 */
    mixin, 
    /** 联合发送 */
    combineEvents) {
        if (combineEvents === void 0) { combineEvents = []; }
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.data = data;
        _this.dwProcess = dwProcess;
        _this.mixin = mixin;
        _this.combineEvents = combineEvents;
        /** 事件 id, 对应上报中的 _event_id */
        _this.id = (_b = (_a = _this.mixin) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : generateGuid_1$1.generateGuid();
        /** 事件来源 */
        _this.from = (_d = (_c = _this.mixin) === null || _c === void 0 ? void 0 : _c.from) !== null && _d !== void 0 ? _d : 'event';
        /** 事件位置 */
        _this.position = 'event';
        /** 失败次数, 超过10次则放弃这个事件 */
        _this.failCount = (_f = (_e = _this.mixin) === null || _e === void 0 ? void 0 : _e.count) !== null && _f !== void 0 ? _f : 0;
        /** 要发送的链接 */
        _this.urls = (_g = _this.mixin) === null || _g === void 0 ? void 0 : _g.urls;
        DWProcess_1$4.DWProcess.printLog('Event', 'constructor', 'generatingEvent', _this);
        if (mixin) {
            (_h = _this.name) !== null && _h !== void 0 ? _h : (_this.name = mixin.name);
            (_j = _this.data) !== null && _j !== void 0 ? _j : (_this.data = mixin.data);
            _this.localDate = mixin.localTime ? new Date(mixin.localTime) : new Date();
            _this.remoteDate = mixin.remoteTime ? new Date(mixin.remoteTime) : dwProcess.getRemoteDate(_this.localDate);
        }
        else {
            _this.localDate = new Date();
            _this.remoteDate = dwProcess.getRemoteDate(_this.localDate);
        }
        if (!_this.urls) {
            _this.generateEventUrls();
        }
        DWProcess_1$4.DWProcess.printLog('Event', 'constructor', 'generatedEvent', _this);
        return _this;
    }
    Object.defineProperty(DWEvent.prototype, "urlsParsed", {
        /** 要发送的链接集合 */
        // public urlsParsed: DW.Event.UrlsParsed = []
        get: function () {
            return [this.urls.replace(/^\(|\)$/g, '').split(' ')[0]];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取事件发送链接
     * @param eventName 事件名
     * @param config 全局配置
     * @returns
     */
    DWEvent.prototype.generateEventUrls = function () {
        var _a, _b, _c, _d, _e, _f;
        var dwProcess = this.dwProcess;
        var dwConfig = dwProcess.dwConfig, dynamicData = dwProcess.dynamicData, Reporter = dwProcess.Reporter;
        var sendEventUrl = (_b = (_a = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.sendUrls) === null || _a === void 0 ? void 0 : _a.urls) !== null && _b !== void 0 ? _b : Reporter.defaults.sendUrl;
        var debugEventUrl = Reporter.defaults.debugUrl;
        var config = dwConfig.getAll();
        var urls = sendEventUrl;
        if (config.dbg) {
            // 不使用 ?? 因为可能是空字符串
            urls = config.dbgUrl ||
                ((_c = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.sendUrls) === null || _c === void 0 ? void 0 : _c.debugUrls) ||
                debugEventUrl;
        }
        else {
            var length_1 = (_f = (_e = (_d = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.events) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
            for (var i = 0; i < length_1; i++) {
                var event_1 = dynamicData.events.data[i];
                if (event_1.name === this.name) {
                    urls = (event_1 === null || event_1 === void 0 ? void 0 : event_1.sendUrls) || sendEventUrl;
                    break;
                }
            }
        }
        DWProcess_1$4.DWProcess.printLog('Event', 'generateEventUrls', '', { urls: urls, name: this.name });
        this.urls = urls;
        return this;
    };
    /** 生成一个事件对象 (事件体中 _events 里的一个元素) */
    DWEvent.prototype.generateEventObject = function () {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h;
        var dwProcess = this.dwProcess;
        var dynamicData = dwProcess.dynamicData;
        // 获取 remoteDate, 但也有可能为空
        if (!this.remoteDate) {
            this.remoteDate = dwProcess.getRemoteDate(this.localDate);
        }
        if (!this.dataEncrypted && this.data) {
            // 生成 dataEncrypted
            dwProcess.emit('event-data-encrypt', {
                dwEvent: this,
                dwProcess: dwProcess,
                eventData: this.data
            });
        }
        var object = {
            _time: dateFormat_1.dateFormat((_b = this.remoteDate) !== null && _b !== void 0 ? _b : this.localDate),
            _session_id: getSessionId_1.getSessionId(),
            _event_id: this.id,
            _abtest_name: (_d = (_c = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.abTestTag) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
            _abtest_group_id: (_f = (_e = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.abTestTag) === null || _e === void 0 ? void 0 : _e.groupId) !== null && _f !== void 0 ? _f : ''
        };
        DWProcess_1$4.DWProcess.printLog('Event', 'generateEventObject', '', tslib_1$6.__assign(tslib_1$6.__assign({ name: this.name }, object), ((_g = this.dataEncrypted) !== null && _g !== void 0 ? _g : this.data)));
        return _a = {
                _type: 'general'
            },
            _a[this.name] = tslib_1$6.__assign(tslib_1$6.__assign({}, object), ((_h = this.dataEncrypted) !== null && _h !== void 0 ? _h : this.data)),
            _a;
    };
    /** 获取发事件请求体中的额外信息内容 */
    DWEvent.prototype.generateEventAdd = function () {
        var dwProcess = this.dwProcess;
        var Reporter = dwProcess.Reporter;
        var osInfo = Reporter.adapters.osInfo;
        var eventAdd = {
            _brand: osInfo.getBrand(),
            _os: osInfo.getOs(),
            _model: osInfo.getModel(),
            _screen: osInfo.getScreen(),
            _os_ver: osInfo.getOsVer(),
            _carrier: osInfo.getCarrier(),
            _network: osInfo.getNetwork(),
            _language: osInfo.getLanguage(),
            _gps: osInfo.getGps()
        };
        return eventAdd;
    };
    /**
     * 获取发送事件的请求体
     * @param name 事件名
     * @param data 事件数据
     * @param config 配置器
     * @param storage 存储器
     */
    DWEvent.prototype.generateEventBody = function () {
        var _a;
        var dwProcess = this.dwProcess;
        var cache = dwProcess.cache, dwConfig = dwProcess.dwConfig;
        var config = dwConfig.getAll();
        var deviceId = config.deviceId || cache.deviceId;
        var currentDate = (_a = dwProcess.getRemoteDate()) !== null && _a !== void 0 ? _a : new Date(); // 当前服务器时间
        var eventBody = {
            _p: config.protocol,
            _st: config.st,
            _sv: config.sv,
            _app: config.appKey,
            _gid: deviceId,
            _did: deviceId,
            _aid: config.accountId,
            _ut: dateFormat_1.dateFormat(currentDate),
            _rid: generateGuid_1$1.generateGuid(),
            _av: config.version,
            _ch: config.channel,
            _dbg: config.dbg,
            _add: this.generateEventAdd()
            // _events: await this.events // 最后组装 events
        };
        Object.assign(eventBody, config.customPublicAttrs);
        return eventBody;
    };
    /** 校验参数 name 和 data */
    DWEvent.prototype.validate = function () {
        if (this.eventValidate) {
            return this;
        }
        // 校验name属性, 必须传入
        if (!this.name) {
            throw Error('"_dw.onEvent(name, data)" call error, name is not allowed to be empty!');
        }
        // 校验name属性是否为字符串类型
        if (this.name && typeof this.name !== 'string') {
            throw Error('"_dw.onEvent(name, data)" call error, name should be String!');
        }
        // 校验data是否为对象类型
        if (typeof this.data !== 'undefined') {
            var typeString = Object.prototype.toString.call(this.data).toLowerCase();
            if (typeString !== '[object object]' && typeString !== '[object null]') {
                throw Error('"_dw.onEvent(name, data)" call error, data should be Object!');
            }
            else {
                // 字符串 数字 布尔值 undefined null（目前只屏蔽值是对象情况）
                for (var i in this.data) {
                    if (Object.prototype.hasOwnProperty.call(this.data, i) &&
                        // eslint-disable-next-line eqeqeq
                        !(this.data[i] == undefined || /string|boolean|number/.test(typeof this.data[i]))) {
                        // null == undefined // true
                        // undefined == undefined // true
                        // 0 == undefined // false
                        // false == undefined // false
                        // '' == undefined // false
                        throw Error('"_dw.onEvent(name, data)" call error, value should be string/number/boolean!');
                    }
                }
            }
        }
        this.eventValidate = true;
        return this;
    };
    /** 生成事件体 */
    DWEvent.prototype.body = function () {
        var _this = this;
        if (this.from !== 'wait') {
            this.validate();
        }
        if (!this.eventBody) {
            this.eventBody = this.generateEventBody();
            // 3.0.18 try/catch 处理
            try {
                this.events = this.eventBody._events = this.data ? [this.generateEventObject()] : [];
            }
            catch (e) {
                // this.events = this.eventBody._events = []
                DWProcess_1$4.DWProcess.printLog('Event', 'body', 'generatedEventBody-error', { event: this, error: e });
            }
            var insertCombineEvents_1 = function (events) {
                events.forEach(function (dwEvent) {
                    var _a;
                    try {
                        dwEvent.name && _this.events.push(dwEvent.generateEventObject());
                        if ((_a = dwEvent.combineEvents) === null || _a === void 0 ? void 0 : _a.length) {
                            insertCombineEvents_1(dwEvent.combineEvents);
                        }
                    }
                    catch (e) {
                        DWProcess_1$4.DWProcess.printLog('Event', 'body', 'combineEvents-generatedEventBody-error', { event: _this, error: e });
                    }
                });
            };
            insertCombineEvents_1(this.combineEvents);
            // this.combineEvents.forEach(dwEvent => {
            //   try {
            //     this.events.push(dwEvent.generateEventObject())
            //   } catch (e) {
            //     DWProcess.printLog('Event', 'body', 'combineEvents-generatedEventBody-error', { event: this, error: e })
            //   }
            // })
            // fix undefined name
            // this.eventBody._events = this.events
            // this.events.push(...this.combineEvents.map(dwEvent => dwEvent.generateEventObject()))
            if (!this.urls) {
                this.generateEventUrls();
            }
        }
        DWProcess_1$4.DWProcess.printLog('Event', 'body', 'generatedEventBody', this);
        return this;
    };
    /**
     * 是否是禁用该事件
     * @param dynamicData
     */
    DWEvent.prototype.checkDisabled = function (dynamicData) {
        var _a, _b, _c;
        var length = (_c = (_b = (_a = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.events) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        for (var i = 0; i < length; i++) {
            var event_2 = dynamicData.events.data[i];
            if (this.name === event_2.name && (event_2.disable === true || event_2.disable === 'true')) {
                return true;
            }
        }
        return false;
    };
    /**
     * 发送
     * @param url 指定地址, 默认从 dwService 里取
     * @returns
     */
    DWEvent.prototype.post = function (url) {
        return tslib_1$6.__awaiter(this, void 0, void 0, function () {
            var dwProcess, dwService, dynamicData, data;
            var _this = this;
            return tslib_1$6.__generator(this, function (_a) {
                dwProcess = this.dwProcess;
                dwService = dwProcess.dwService, dynamicData = dwProcess.dynamicData;
                // 保存 url
                url && (this.urls = url);
                // if (url) {
                //   this.urls = url
                // } else {
                //   // 避免动参返回前发送的事件 url 不正确
                //   // TODO 考虑 SDK 整体逻辑，所有的行为在获取动参后进行，避免逻辑复杂
                //   this.generateEventUrls()
                // }
                // 判断是否中止
                if (this.isPostStopped()) {
                    DWProcess_1$4.DWProcess.printLog('Event', 'post', 'event stopped', this, true);
                    return [2 /*return*/, false];
                }
                if (dwProcess.state === 'prepare') {
                    DWProcess_1$4.DWProcess.printLog('Event', 'post', 'process preparing', this, true);
                    // 没有的时候先保存
                    // 销毁
                    this.saveCache();
                    // this.destroy()
                    return [2 /*return*/, false];
                }
                // 校验该事件是否过期
                if (this.checkDisabled(dynamicData)) {
                    // 销毁
                    DWProcess_1$4.DWProcess.printLog('Event', 'post', 'event Expired', this, true);
                    // this.destroy()
                    return [2 /*return*/, false];
                }
                // 对 this 进行修改
                // 1. 判断是否中止发送
                dwProcess.emit('before-event-send', {
                    dwEvent: this,
                    dwProcess: dwProcess
                });
                // 事件过后判断是否中止发送
                if (this.isPostStopped()) {
                    DWProcess_1$4.DWProcess.printLog('Event', 'post', 'event stopped 2', this, true);
                    return [2 /*return*/, false];
                }
                // 事件体和 urls
                this.body();
                // 加密
                if (!this.eventBodyEncrypted) {
                    dwProcess.emit('event-body-encrypt', {
                        dwEvent: this,
                        dwProcess: dwProcess,
                        eventBody: this.eventBody
                    });
                }
                data = this.eventBodyEncrypted;
                // 在 await 后再次检查
                if (this.isPostStopped()) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var urlsIndex = 0; // 当前发送的 urls 的 index
                        var urlsLineIndex = 0; // 当前正在发送的 urls 这一行的 index
                        var emit = function (error, response) {
                            dwProcess.emit('after-event-send', {
                                dwEvent: _this,
                                dwProcess: dwProcess,
                                response: {
                                    error: error,
                                    data: response
                                }
                            });
                        };
                        var send = function () {
                            var url;
                            var urlsLine = _this.urlsParsed[urlsIndex];
                            if (!urlsLine) {
                                // 所有行已发送完
                                return resolve(true);
                            }
                            if (typeof urlsLine === 'string') {
                                url = urlsLine;
                            }
                            else {
                                if (urlsLine.length > urlsLineIndex) {
                                    url = urlsLine[urlsLineIndex];
                                }
                                else {
                                    // 当前行已发送完
                                    urlsLineIndex = 0;
                                    urlsIndex++;
                                    return send();
                                }
                            }
                            dwService.sendEvent(url, data, function (error, response) {
                                if (error) {
                                    if (urlsIndex === _this.urlsParsed.length - 1) {
                                        // 当前是最后一行, 结束所有 url 的发送
                                        // 销毁
                                        _this.saveFail().log('event upload fail');
                                        emit(error, response);
                                        resolve(false);
                                    }
                                    else {
                                        // 失败没关系, 下一个
                                        urlsIndex++;
                                        send();
                                    }
                                    // if (typeof urlsLine === 'string') {
                                    // } else {
                                    //   // 在 and 组中发送失败了
                                    //   this.saveFail().log('event upload fail')
                                    //   emit(error, response)
                                    //   resolve(false)
                                    // }
                                }
                                else {
                                    if (typeof urlsLine === 'string' || urlsLineIndex === urlsLine.length - 1) {
                                        // 当前行发送成功, 代表发送成功
                                        _this.log('event upload success', { url: url });
                                        emit(error, response);
                                        // this.destroy()
                                        resolve(true);
                                    }
                                    else {
                                        // 当前行没发完, 继续发送
                                        urlsLineIndex++;
                                        send();
                                    }
                                }
                                // 在这里, 这个 dwEvent 的声明周期就结束了
                                // sendWaitEvents 会创建新的 dwEvent
                            });
                        };
                        send();
                    })];
            });
        });
    };
    DWEvent.prototype.generateCommonStorageEvent = function () {
        var _a, _b;
        return {
            id: this.id,
            name: this.name,
            from: this.from,
            localTime: this.localDate.getTime(),
            remoteTime: (_b = (_a = this.remoteDate) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0,
            data: this.data
        };
    };
    /** 保存到本地缓存, 保存处理之前的 data (指过了 validate 的) */
    DWEvent.prototype.saveCache = function () {
        var dwProcess = this.dwProcess;
        var dwStorage = dwProcess.dwStorage;
        this.cancelStopPost();
        // fix undefined name
        if (this.position !== 'cache') {
            this.position = 'cache';
            // if (!this.name && !this.data && this.mixin.from === 'wait') {
            //   if (this.combineEvents.length) {
            //     DWProcess.printLog('Event', 'saveCache', 'saving combineEvents', this.combineEvents)
            //     dwStorage.cache.save(this.combineEvents)
            //   }
            // } else {
            //   DWProcess.printLog('Event', 'saveCache', 'saving events', this)
            //   dwStorage.cache.save([this])
            // }
            DWProcess_1$4.DWProcess.printLog('Event', 'saveCache', 'saving events', this);
            dwStorage.cache.save([this]);
        }
        return this;
    };
    /** 保存到本地待发送, 保存的是处理完毕后确定要发送的 events */
    DWEvent.prototype.saveWait = function () {
        DWProcess_1$4.DWProcess.printLog('Event', 'saveWait', 'saving events', this);
        var dwProcess = this.dwProcess;
        var dwStorage = dwProcess.dwStorage;
        var payload = [];
        var push = function (dwEvent) {
            if (dwEvent.position !== 'wait') {
                dwEvent.position = 'wait';
                payload.push(dwEvent);
            }
        };
        this.cancelStopPost();
        // 有数据时, 一个普通事件
        if (this.data) {
            push(this);
        }
        // 批量发送时, 分开保存
        this.combineEvents.forEach(push);
        dwStorage.wait.save(payload);
        return this;
    };
    /** 保存失败事件到本地 */
    DWEvent.prototype.saveFail = function () {
        DWProcess_1$4.DWProcess.printLog('Event', 'saveFail', 'saving events', this);
        var dwProcess = this.dwProcess;
        var dwStorage = dwProcess.dwStorage;
        var maxFailCount = parseInt("10");
        var payload = [];
        var push = function (dwEvent) {
            if (dwEvent.failCount < maxFailCount && dwEvent.position !== 'fail') {
                dwEvent.position = 'fail';
                payload.push(dwEvent);
            }
        };
        this.cancelStopPost();
        // console.log('saveFail', this.failCount, maxFailCount)
        if (this.data) {
            push(this);
        }
        this.combineEvents.forEach(push);
        dwStorage.fail.save(payload);
        return this;
    };
    /**
     * 打印当前 dwEvent
     * @param tag 标签
     * @param options 配置
     * @param options.name @default =this.name
     * @param options.data @default =this.data
     * @param options.url @default =this.url
     * @param options.body @default =this.body
     */
    DWEvent.prototype.log = function (tag, options) {
        if (options === void 0) { options = {}; }
        var dwProcess = this.dwProcess;
        var _a = options.name, name = _a === void 0 ? this.name : _a, _b = options.data, data = _b === void 0 ? this.data : _b, _c = options.url, url = _c === void 0 ? this.urls : _c, _d = options.body, body = _d === void 0 ? this.eventBody : _d;
        DWProcess_1$4.DWProcess.printLog('LOG', tag, '', { time: new Date().toLocaleString(), name: name, data: data, url: url, length: body._events.length, body: body }, true, dwProcess.dwConfig.get('dbg'));
        return this;
    };
    /** 销毁事件 */
    DWEvent.prototype.destroy = function () {
        this.data = null;
        this.mixin = null;
        this.combineEvents.length = 0;
        this.dataEncrypted = null;
        this.events = null;
        this.eventBody = null;
        this.eventBodyEncrypted = null;
    };
    return DWEvent;
}(DWRequest_1.DWRequest));
DWEvent$1.DWEvent = DWEvent;

var DWStorage$1 = {};

var typings = {};

(function (exports) {
/* eslint-disable no-unused-vars */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
(function (Storage) {
    (function (Name) {
        Name["STORE_FIRST_VISIT_NAME"] = "dw_store_first_item_token";
        Name["STORE_START_TIMESTAMP_NAME"] = "dw_store_timestamp_key";
        Name["STORE_FAILED_EVENTS_NAME"] = "dw_store_queen_data_events";
        Name["STORE_WAIT_SEND_EVENTS_NAME"] = "dw_store_wait_send_events";
        Name["STORE_CACHE_EVENTS_NAME"] = "dw_store_cache_events";
        Name["STORE_DYNAMIC_DATA_NAME"] = "dw_store_dynamic_data";
        /** 服务器时间和本地时间差值 */
        Name["STORE_TIME_DIFFERENCE"] = "dw_store_time_sub";
    })(Storage.Name || (Storage.Name = {}));
    (function (CommonName) {
        CommonName["STORE_DEVICE_ID_NAME"] = "dw_store_device_id_key";
    })(Storage.CommonName || (Storage.CommonName = {}));
})(exports.Storage || (exports.Storage = {}));
}(typings));

// 存储器
Object.defineProperty(DWStorage$1, "__esModule", { value: true });
DWStorage$1.DWStorage = void 0;
var tslib_1$5 = require$$0$1;
var typings_1$2 = typings;
// import { copy } from '@/utils/copy'
var generateGuid_1 = generateGuid$1;
// import { getStringSize } from '@/utils/getStringSize'
var DWEvent_1$2 = DWEvent$1;
var DWProcess_1$3 = DWProcess$1;
/**
 * 1. cacheEvents
 * 2. waitEvents
 * 3. failEvents
 */
/**
 * 事件存储到内存, 并同步写入本地
 */
var CacheStorage = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function CacheStorage(name, dwStorage, generateSyncData) {
        this.name = name;
        this.dwStorage = dwStorage;
        this.generateSyncData = generateSyncData;
        this.data = [];
        this.suffixCount = 0;
        CacheStorage.instances.push(this);
    }
    /** 存 */
    CacheStorage.prototype.save = function (data) {
        var _a, _b;
        var instances = CacheStorage.instances, maxLength = CacheStorage.maxLength;
        var currentLength = instances.reduce(function (result, item) {
            return (result += item.data.length);
        }, 0);
        var difference = currentLength + data.length - maxLength;
        if (difference <= 0) {
            (_a = this.data).push.apply(_a, tslib_1$5.__spreadArray([], tslib_1$5.__read(data)));
        }
        else {
            // 丢掉新的
            var spliceLength = data.length - difference;
            if (spliceLength > 0) {
                (_b = this.data).push.apply(_b, tslib_1$5.__spreadArray([], tslib_1$5.__read(data.slice(0, spliceLength))));
            }
        }
        // if (this.data.length > maxLength) {
        //   // 去掉旧的
        //   this.data.splice(0, this.data.length - maxLength)
        // }
        this.debounceSync();
        // let localString = JSON.stringify(localEvents)
        // while (localEvents.length > 0) {
        //   // 加一个存储限制
        //   if (getStringSize(localString) > parseInt(process.env.DW_MAX_STORAGE_STRING_LENGTH)) {
        //     console.warn('[dw]reach storage save limit size!')
        //     // 从顶部删除, 直到长度打到限制之内
        //     localEvents.shift()
        //     localString = JSON.stringify(localEvents)
        //   } else {
        //     break
        //   }
        // }
    };
    /** 读 */
    CacheStorage.prototype.read = function () {
        // 不用 copy 节约一点性能
        return this.data;
    };
    /** 重置 */
    CacheStorage.prototype.reset = function () {
        // 不用 data.length = 0, 因为 read 返回的是 data 本体
        this.data = [];
        clearTimeout(this.debounceSyncTimer);
        this.sync();
    };
    /** 同步到本地 */
    CacheStorage.prototype.sync = function () {
        return this.dwStorage.set(this.name, JSON.stringify(this.data.map(this.generateSyncData))).catch();
    };
    CacheStorage.prototype.debounceSync = function () {
        var _this = this;
        var _a = this, dwStorage = _a.dwStorage, data = _a.data;
        clearTimeout(this.debounceSyncTimer);
        this.debounceSyncTimer = setTimeout(function () {
            if (dwStorage.suffix) {
                _this.suffixCount = 0;
                dwStorage.set(_this.name, JSON.stringify(data.map(_this.generateSyncData))).catch();
            }
            else {
                if (_this.suffixCount < parseInt("60;")) {
                    _this.debounceSync();
                }
                _this.suffixCount++;
            }
        }, 100);
    };
    /** 从本地读取 */
    CacheStorage.prototype.resync = function (dwProgress) {
        var _this = this;
        return this.dwStorage.get(this.name).then(function (res) {
            var _a;
            try {
                if (res === '') {
                    res = '[]';
                }
                var data = JSON.parse(res);
                (_a = _this.data).push.apply(_a, tslib_1$5.__spreadArray([], tslib_1$5.__read(data.map(function (item) { return new DWEvent_1$2.DWEvent(null, null, dwProgress, item); }))));
            }
            catch (e) {
                DWProcess_1$3.DWProcess.printLog('Storage', 'resync', 'ERROR', e, true);
                _this.reset();
            }
        });
    };
    CacheStorage.instances = [];
    CacheStorage.maxLength = parseInt("5000");
    return CacheStorage;
}());
/**
 * 存储器
 * @description 公用存储, 比如 localTimeSub, deviceId 等, 定为静态方法
 * @description 多个 Reporter 的存储, 通过 setSuffix(suffix) 设置存储后缀区分, 定为实例方法
 */
var DWStorage = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function DWStorage(Reporter) {
        this.Reporter = Reporter;
        /**
         * 3.0.14 之前, 缓存事件分两个阶段存储:
         *   1. 动参返回前, 保存到内存的 this.cacheEvents 里
         *   2. 动参返回后, 保存到本地的 this.cache 里
         * 3.0.14 及以后, this.cache 改为内存存储本地同步的方式, 缓存事件合并保存到内存 this.cache 里, this.cacheEvents 废弃
         */
        // public cacheEvents: DW.Event.Save.Cache = []
        this.cache = new CacheStorage(typings_1$2.Storage.Name.STORE_CACHE_EVENTS_NAME, this, function (dwEvent) { return (tslib_1$5.__assign({ type: 'cache' }, dwEvent.generateCommonStorageEvent())); });
        this.wait = new CacheStorage(typings_1$2.Storage.Name.STORE_WAIT_SEND_EVENTS_NAME, this, function (dwEvent) { return (tslib_1$5.__assign({ type: 'wait', urls: dwEvent.urls }, dwEvent.generateCommonStorageEvent())); });
        this.fail = new CacheStorage(typings_1$2.Storage.Name.STORE_FAILED_EVENTS_NAME, this, function (dwEvent) { return (tslib_1$5.__assign({ type: 'fail', urls: dwEvent.urls, count: dwEvent.failCount + 1 }, dwEvent.generateCommonStorageEvent())); });
    }
    /**
     * 将本地事件读取到内存中
     */
    DWStorage.prototype.readEvents = function (dwProcess) {
        return Promise.all([
            this.cache.resync(dwProcess),
            this.wait.resync(dwProcess),
            this.fail.resync(dwProcess)
        ]);
    };
    /**
     * 读取设备ID
     * @description 如果没有读取到设备ID, 则生成一个新的, 然后保存并返回
     * @returns
     */
    DWStorage.prototype.readDeviceId = function (appKey, dwConfig) {
        return tslib_1$5.__awaiter(this, void 0, void 0, function () {
            var _a, storage, osInfo, isWeb, deviceIdCommonName, deviceIdV2Name, check, systemDeviceId, commonDeviceId, v2DeviceId, deviceIdV2Pre, length_1, i, key, v2OtherDeviceId, generatedDeviceId_1, generatedDeviceId;
            return tslib_1$5.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.Reporter.adapters, storage = _a.storage, osInfo = _a.osInfo;
                        // 等待 setDeviceKey 执行
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve); })];
                    case 1:
                        // 等待 setDeviceKey 执行
                        _b.sent();
                        isWeb = storage.type === 'web';
                        deviceIdCommonName = typings_1$2.Storage.CommonName.STORE_DEVICE_ID_NAME;
                        deviceIdV2Name = deviceIdCommonName + "@" + appKey;
                        check = function () {
                            var deviceId = dwConfig.get('deviceId');
                            storage.set(deviceIdV2Name, deviceId);
                            return deviceId;
                        };
                        DWProcess_1$3.DWProcess.printLog('Storage', 'readDeviceId', '', { deviceId: check() });
                        if (check())
                            return [2 /*return*/, check()
                                // 从系统获取 deviceId (除了 web, 所以不用同步)
                            ];
                        return [4 /*yield*/, osInfo.getDeviceId()];
                    case 2:
                        systemDeviceId = _b.sent();
                        if (check())
                            return [2 /*return*/, check()];
                        if (systemDeviceId)
                            return [2 /*return*/, systemDeviceId
                                // 读取通用的 deviceId
                            ];
                        return [4 /*yield*/, storage.get(deviceIdCommonName)];
                    case 3:
                        commonDeviceId = _b.sent();
                        if (check())
                            return [2 /*return*/, check()
                                // 优先级1: 自己的
                            ];
                        // 优先级1: 自己的
                        if (isWeb) {
                            v2DeviceId = window.localStorage.getItem(deviceIdV2Name);
                            if (v2DeviceId) {
                                // 没有通用时, 同步到通用
                                if (!commonDeviceId) {
                                    this.syncDeviceId(v2DeviceId, appKey, { common: 'cover' });
                                }
                                return [2 /*return*/, v2DeviceId];
                            }
                            // 优先级2: 通用的
                            if (commonDeviceId) {
                                // 将通用的同步到自己
                                this.syncDeviceId(commonDeviceId, appKey, { self: 'cover' });
                                return [2 /*return*/, commonDeviceId];
                            }
                            deviceIdV2Pre = deviceIdCommonName + "@";
                            length_1 = window.localStorage.length;
                            for (i = 0; i < length_1; i++) {
                                key = window.localStorage.key(i);
                                if (key.indexOf(deviceIdV2Pre) === 0) {
                                    v2OtherDeviceId = window.localStorage.getItem(key);
                                    if (v2OtherDeviceId) {
                                        this.syncDeviceId(v2OtherDeviceId, appKey, { common: 'cover', self: 'cover' });
                                        return [2 /*return*/, v2OtherDeviceId];
                                    }
                                }
                            }
                            generatedDeviceId_1 = generateGuid_1.generateGuid();
                            this.syncDeviceId(generatedDeviceId_1, appKey, { common: 'cover', self: 'cover' });
                            return [2 /*return*/, generatedDeviceId_1];
                        }
                        // 优先级2: 通用的
                        if (commonDeviceId) {
                            return [2 /*return*/, commonDeviceId];
                        }
                        generatedDeviceId = generateGuid_1.generateGuid();
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 8]);
                        return [4 /*yield*/, storage.set(deviceIdCommonName, generatedDeviceId)];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.readDeviceId(appKey, dwConfig)];
                    case 7: return [2 /*return*/, _b.sent()];
                    case 8: return [2 /*return*/, generatedDeviceId];
                }
            });
        });
    };
    /**
     * 同步设备ID到所有本地存储 (为兼容 2.x 多实例)
     * @param deviceId 设备ID
     * @param appKey 应用ID
     */
    DWStorage.prototype.syncDeviceId = function (deviceId, appKey, positions) {
        var storage = this.Reporter.adapters.storage;
        var deviceIdCommonName = typings_1$2.Storage.CommonName.STORE_DEVICE_ID_NAME;
        DWProcess_1$3.DWProcess.printLog('Storage', 'syncDeviceId', '', { positions: positions, deviceId: deviceId, appKey: appKey });
        // 当使用 localStorage 存储时, 需要兼容 2.x 多实例
        if (storage.type === 'web' && appKey) {
            // 以下是 v3.0.14 同步所有 deviceId 的逻辑
            // try {
            //   const deviceIdCommonName = Storage.CommonName.STORE_DEVICE_ID_NAME
            //   const deviceIdV2Pre = `${deviceIdCommonName}@`
            //   const deviceIdV2Name = `${deviceIdCommonName}@${appKey}`
            //   const deviceOldNames: string[] = []
            //   const length = window.localStorage.length
            //   for (let i = 0; i < length; i++) {
            //     const key = window.localStorage.key(i)
            //     if (key.indexOf(deviceIdV2Pre) === 0) {
            //       deviceOldNames.push(key)
            //     }
            //   }
            //   window.localStorage.setItem(deviceIdCommonName, deviceId)
            //   window.localStorage.setItem(deviceIdV2Name, deviceId)
            //   deviceOldNames.forEach(name => window.localStorage.setItem(name, deviceId))
            // } catch (err) {}
            // v3.0.15 只同步部分 deviceId
            var deviceIdV2Name_1 = deviceIdCommonName + "@" + appKey;
            switch (positions.self) {
                case 'cover':
                    storage.set(deviceIdV2Name_1, deviceId);
                    break;
                case 'fill':
                    setTimeout(function () {
                        storage.get(deviceIdV2Name_1).then(function (value) {
                            !value && storage.set(deviceIdV2Name_1, deviceId);
                        });
                    }, 50);
                    break;
            }
        }
        switch (positions.common) {
            case 'cover':
                storage.set(deviceIdCommonName, deviceId);
                break;
            case 'fill':
                setTimeout(function () {
                    storage.get(deviceIdCommonName).then(function (value) {
                        !value && storage.set(deviceIdCommonName, deviceId);
                    });
                }, 50);
                break;
        }
    };
    /**
     * 在业务中使用 appKey 作为后缀
     * @param suffix 后缀
     */
    DWStorage.prototype.setSuffix = function (suffix) {
        this.suffix = suffix;
    };
    DWStorage.prototype.set = function (key, value) {
        var innerKey = this.getInnerKey(key);
        return this.Reporter.adapters.storage.set(innerKey, value);
    };
    DWStorage.prototype.get = function (key) {
        var innerKey = this.getInnerKey(key);
        return this.Reporter.adapters.storage.get(innerKey);
    };
    DWStorage.prototype.rm = function (key) {
        var innerKey = this.getInnerKey(key);
        return this.Reporter.adapters.storage.rm(innerKey);
    };
    /**
     * 获取当前实例的存储名
     * @param key 存储名
     * @returns
     */
    DWStorage.prototype.getInnerKey = function (key) {
        return this.suffix ? key + "_" + this.suffix : key;
    };
    /**
     * 获取用户是否之前访问过站点(新增用户判断条件)，有值即为已访问
     * @returns
     */
    DWStorage.prototype.readIsFirstVisit = function () {
        return tslib_1$5.__awaiter(this, void 0, void 0, function () {
            return tslib_1$5.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(typings_1$2.Storage.Name.STORE_FIRST_VISIT_NAME)];
                    case 1: return [2 /*return*/, ((_a.sent()) !== 'true')];
                }
            });
        });
    };
    /**
     * 本地存储用户已经访问过该站点
     */
    DWStorage.prototype.saveVisitAlready = function () {
        return this.set(typings_1$2.Storage.Name.STORE_FIRST_VISIT_NAME, 'true');
    };
    /**
     * 保存动参返回值
     * @param data 返回值
     */
    DWStorage.prototype.saveDynamicData = function (data) {
        if (typeof data === 'object') {
            return this.set(typings_1$2.Storage.Name.STORE_DYNAMIC_DATA_NAME, JSON.stringify(data));
        }
    };
    /**
     * 读取动参返回值
     */
    DWStorage.prototype.readDynamicData = function () {
        return tslib_1$5.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1$5.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.get(typings_1$2.Storage.Name.STORE_DYNAMIC_DATA_NAME)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, JSON.parse(result || 'null')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DWStorage.prototype.removeDynamicData = function () {
        return tslib_1$5.__awaiter(this, void 0, void 0, function () {
            return tslib_1$5.__generator(this, function (_a) {
                return [2 /*return*/, this.rm(typings_1$2.Storage.Name.STORE_DYNAMIC_DATA_NAME)];
            });
        });
    };
    /**
     * 存储服务器时间和本地时间的差值
     * @param {number} [timeDifference=0] 服务器时间差
     */
    DWStorage.prototype.saveTimeDifference = function (timeDifference) {
        if (timeDifference === void 0) { timeDifference = 0; }
        return this.set(typings_1$2.Storage.Name.STORE_TIME_DIFFERENCE, timeDifference.toString());
    };
    /**
     * 获取服务器时间和本地时间差值
     * @returns
     */
    DWStorage.prototype.readTimeDifference = function () {
        return tslib_1$5.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1$5.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(typings_1$2.Storage.Name.STORE_TIME_DIFFERENCE)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, parseInt(result || '0')];
                }
            });
        });
    };
    return DWStorage;
}());
DWStorage$1.DWStorage = DWStorage;

var DWService$1 = {};

// 发送器, 源自 src/http.js
Object.defineProperty(DWService$1, "__esModule", { value: true });
DWService$1.DWService = void 0;
var DWEvent_1$1 = DWEvent$1;
var typings_1$1 = typings$1;
var DWProcess_1$2 = DWProcess$1;
var DWService = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function DWService(Reporter) {
        this.Reporter = Reporter;
    }
    /**
     * 发送缓存事件
     * @param dwProcess
     */
    DWService.prototype.sendCacheEvents = function (dwProcess) {
        var dwStorage = dwProcess.dwStorage;
        // 读取
        var data = dwStorage.cache.read();
        // 清空
        dwStorage.cache.reset();
        // 转移
        dwStorage.wait.save(data);
        // 发送
        data.length && DWProcess_1$2.DWProcess.printLog('Service', 'sendCacheEvents', '', data);
        this.sendWaitEvents(dwProcess);
    };
    /**
     * 发送失败的事件
     * @description 已加密
     * @description 在请求动参成功后进行发送, 每 SPLIT_SIZE 条数据发一次
     */
    DWService.prototype.sendFailEvents = function (dwProcess) {
        var dwStorage = dwProcess.dwStorage;
        // 读取
        var data = dwStorage.fail.read();
        // 清空
        dwStorage.fail.reset();
        // 转移
        dwStorage.wait.save(data);
        // 发送
        data.length && DWProcess_1$2.DWProcess.printLog('Service', 'sendFailEvents', '', data);
        this.sendWaitEvents(dwProcess);
    };
    /**
     * 发送等待发送的事件
     * @description 调用前确认已获取动参
     * @description 这些数据需要检查加密等
     */
    DWService.prototype.sendWaitEvents = function (dwProcess) {
        var _a, _b, _c, _d;
        var dwStorage = dwProcess.dwStorage, dynamicData = dwProcess.dynamicData;
        // 读取
        var data = dwStorage.wait.read();
        data.length && DWProcess_1$2.DWProcess.printLog('Service', 'sendWaitEvents', '', data);
        // 中止
        if (!data.length) {
            return;
        }
        // 重置
        dwStorage.wait.reset();
        // 归纳 (以 url 归纳)
        var ids = {};
        var currentTime = ((_a = dwProcess.getRemoteDate()) !== null && _a !== void 0 ? _a : new Date()).getTime();
        var map = data.reduce(function (result, dwEvent) {
            var _a;
            // 判断过期时间 (一个月)
            if (currentTime - ((_a = dwEvent.remoteDate) !== null && _a !== void 0 ? _a : dwEvent.localDate).getTime() > DWService.maxExpireTime) {
                return result;
            }
            // 在遍历时去重
            if (dwEvent.id in ids) {
                return result;
            }
            ids[dwEvent.id] = 1;
            // 分类
            if (!result[dwEvent.urls]) {
                result[dwEvent.urls] = [];
            }
            result[dwEvent.urls].push(dwEvent);
            // 在遍历时重置 position
            dwEvent.position = 'event';
            return result;
        }, {});
        DWProcess_1$2.DWProcess.printLog('Service', 'sendWaitEvents', 'eventMap', map);
        var splitNumber = (_d = (_c = (_b = dynamicData === null || dynamicData === void 0 ? void 0 : dynamicData.uploadStrategy) === null || _b === void 0 ? void 0 : _b.transportControl) === null || _c === void 0 ? void 0 : _c.splitSize) !== null && _d !== void 0 ? _d : parseInt("100");
        // 发送
        for (var key in map) {
            if (Object.prototype.hasOwnProperty.call(map, key)) {
                var events = map[key];
                // const restEvents = events.splice(splitNumber) // 切除
                DWProcess_1$2.DWProcess.printLog('Service', 'sendWaitEvents', 'newEvent-combineEvents', { key: key, events: events });
                for (var i = 0; i < Math.ceil(events.length / splitNumber); i++) {
                    new DWEvent_1$1.DWEvent(null, null, dwProcess, { from: 'wait' }, events.slice(splitNumber * i, splitNumber * (i + 1))).post();
                }
            }
        }
    };
    /**
     * 发送事件
     */
    DWService.prototype.sendEvent = function (url, data, callback) {
        return this.Reporter.adapters.http.send(url, {
            type: typings_1$1.Http.Type.POST,
            data: data,
            header: {
                'dw-protocol': "1.0"
            },
            timeout: parseInt("3000")
        }, callback);
    };
    DWService.maxExpireTime = 30 * 24 * 60 * 60 * 1000;
    return DWService;
}());
DWService$1.DWService = DWService;

Object.defineProperty(Reporter$1, "__esModule", { value: true });
Reporter$1.Reporter = void 0;
var tslib_1$4 = require$$0$1;
var validateBoolean_1 = validateBoolean$1;
var validateDeviceId_1 = validateDeviceId$1;
var validateString_1 = validateString$1;
var DWConfig_1 = DWConfig$1;
var DWEvent_1 = DWEvent$1;
var DWProcess_1$1 = DWProcess$1;
var DWStorage_1 = DWStorage$1;
var DWService_1 = DWService$1;
var Reporter = /** @class */ (function () {
    function Reporter(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.options = options;
        /** 主要进程 */
        this.dwProcess = new DWProcess_1$1.DWProcess(Reporter, new DWConfig_1.DWConfig(Reporter), new DWStorage_1.DWStorage(Reporter), new DWService_1.DWService(Reporter));
        /**
         * 当前版本
         * @see readme
         */
        this.version = "3.0.27";
        // use + 绑定事件到progress
        // NOTE 似乎太绕，考虑是否有更好的方案
        if (Reporter.defaultBinds.length) {
            Reporter.defaultBinds.forEach(function (item) {
                _this.dwProcess.on(item.event, item.callback);
            });
        }
        DWProcess_1$1.DWProcess.printLog('Reporter', 'init');
    }
    /**
     * 添加一个默认事件绑定
     * @param item 事件项
     */
    Reporter.appendPreBind = function (item) {
        for (var i = 0; i < this.defaultBinds.length; i++) {
            // 避免重复绑定
            if (this.defaultBinds[i].name === item.name) {
                return this;
            }
        }
        this.defaultBinds.push(item);
        // return this
    };
    /**
     * 使用插件
     * @param plugin 插件
     * @param options 插件配置
     */
    Reporter.use = function (plugin, options) {
        plugin.install(this, options);
    };
    /**
     * 上报事件
     * NOTE 需要增加参数以支持立即发送，不走节流，以改善离开页面时发送事件cancel的问题
     * NOTE 需要增加参数以支持走sendBeacon，以部分解决（兼容性）离开页面时发送事件cancel的问题
     * @param name 事件名
     * @param data 事件数据
     * @param options 发送配置
     * @see readme
     */
    Reporter.prototype.onEvent = function (name, data) {
        if (data === void 0) { data = {}; }
        DWProcess_1$1.DWProcess.printLog('Reporter', 'onEvent', name, data, true);
        if (data === null) {
            data = {};
        }
        new DWEvent_1.DWEvent(name, data, this.dwProcess).validate().post();
    };
    /**
     * 设置用户ID
     * @param accountId 用户ID
     * @returns
     * @see readme
     */
    Reporter.prototype.setAccountId = function (accountId) {
        if (accountId === void 0) { accountId = ''; }
        this.dwProcess.dwConfig.set('accountId', String(accountId));
        DWProcess_1$1.DWProcess.printLog('Reporter', 'setAccountId', accountId);
        return this;
    };
    /**
     * 设置 appKey
     * @param appKey appKey
     * @returns
     * @see readme
     * @description 会出现问题:
     * 在没有设置appKey时, 调用了其他修改config的方法, 然后storage把这些配置直接存储, 而没有suffix
     */
    Reporter.prototype.setAppKey = function (appKey) {
        var _this = this;
        if (appKey && validateString_1.validateString(appKey, 'dw.setAppKey(appKey)')) {
            var suffix_1 = appKey;
            if (this.options.storageSuffix) {
                suffix_1 += '_' + this.options.storageSuffix;
            }
            var todo_1 = function () {
                _this.dwProcess.dwStorage.setSuffix(suffix_1);
                DWProcess_1$1.DWProcess.printLog('Reporter', 'setSuffix', suffix_1);
                _this.dwProcess.prepare().then(function () { return _this.dwProcess.init(); });
            };
            if (DWProcess_1$1.DWProcess.instances.find(function (dwProcess) { return dwProcess.dwConfig.get('appKey') === appKey; })) {
                // TODO: 探索 nextTick 方式
                setTimeout(function () { return todo_1(); }, 300);
            }
            else {
                todo_1();
            }
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setAppKey', appKey);
            this.dwProcess.dwConfig.set('appKey', appKey);
        }
        return this;
    };
    /**
     * 设置渠道
     * @param channel 渠道
     * @returns
     * @see readme
     */
    Reporter.prototype.setChannel = function (channel) {
        if (channel && validateString_1.validateString(channel, 'dw.setChannel(channel)')) {
            this.dwProcess.dwConfig.set('channel', channel);
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setChannel', channel);
        }
        return this;
    };
    /**
     * 设置自定义上报
     * @param key 自定义上报名
     * @description 如果key传入的是一个对象, 则会替代原自定义上报的所有内容
     * @param value 自定义上报值
     * @returns
     * @see readme
     */
    Reporter.prototype.setCustomPublicAttrs = function (key, value) {
        DWProcess_1$1.DWProcess.printLog('Reporter', 'setCustomPublicAttrs', '', key);
        if (key) {
            if (typeof key === 'string') {
                this.dwProcess.dwConfig.setCustomPublicAttrs(key, value);
                return this;
            }
            if (typeof key === 'object') {
                this.dwProcess.dwConfig.set('customPublicAttrs', key);
                return this;
            }
        }
        throw Error('sdk error: setCustomPublicAttrs(key, value) arguments error!');
    };
    /**
     * 是否使用自定义PV上报, 若开启, 则使用 sendPageView 方法上报PV
     * @param customPV 是否使用自定义PV上报
     * @returns
     * @see readme
     */
    Reporter.prototype.setCustomPV = function (customPV) {
        if (validateBoolean_1.validateBoolean(customPV, 'dw.setCustomPV(bool)')) {
            this.dwProcess.dwConfig.set('customPV', customPV);
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setCustomPV', '', customPV);
        }
        return this;
    };
    /**
     * 是否打开调试模式, 若开启, 则不会有上报请求发送, 可以查看本地 console
     * @param dbg 是否打开调试模式
     * @returns
     * @see readme
     */
    Reporter.prototype.setDebug = function (dbg, dbgUrl, noEncrypted) {
        if (dbgUrl === void 0) { dbgUrl = ''; }
        if (noEncrypted === void 0) { noEncrypted = false; }
        if (validateBoolean_1.validateBoolean(dbg, 'dw.setDebug(debug, [url], noEncrypted)')) {
            this.dwProcess.dwConfig.set('dbg', dbg);
        }
        if (dbgUrl && validateString_1.validateString(dbgUrl, 'dw.setDebug(debug, [url], noEncrypted)')) {
            this.dwProcess.dwConfig.set('dbgUrl', dbgUrl);
        }
        if (dbgUrl && validateBoolean_1.validateBoolean(noEncrypted, 'dw.setDebug(debug, [url], noEncrypted)')) {
            this.dwProcess.dwConfig.set('noEncrypted', noEncrypted);
        }
        return this;
    };
    /**
     * 是否开启默认事件
     * @param defaultEvents 是否开启默认事件
     * @returns
     * @see readme
     */
    Reporter.prototype.setDefaultEvents = function (defaultEvents) {
        if (validateBoolean_1.validateBoolean(defaultEvents, 'dw.setDefaultEvents(bool)')) {
            this.dwProcess.dwConfig.set('defaultEvents', defaultEvents);
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setDefaultEvents', '', defaultEvents);
        }
        return this;
    };
    /**
     * 设置设备ID
     * @param deviceId 设备ID
     * @returns
     * @see readme
     */
    Reporter.prototype.setDeviceKey = function (deviceId) {
        if (deviceId && validateDeviceId_1.validateDeviceId(deviceId)) {
            var _a = this.dwProcess, dwConfig = _a.dwConfig, dwStorage = _a.dwStorage;
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setDeviceKey', deviceId);
            dwConfig.set('deviceId', deviceId);
            dwStorage.syncDeviceId(deviceId, dwConfig.get('appKey'), {
                common: 'fill',
                self: 'fill'
            });
        }
        return this;
    };
    Reporter.prototype.setDefaultEventsData = function (data, position) {
        if (position === void 0) { position = 'common'; }
        var dwProcess = this.dwProcess;
        new DWEvent_1.DWEvent('_setDefaultEventsData', data, dwProcess).validate();
        DWProcess_1$1.DWProcess.printLog('Reporter', 'setDefaultEventsData', '', { data: data, position: position });
        dwProcess.cache.defaultEventsData[position] = data;
        return this;
    };
    /**
     * 设置 app_end 事件上报时的额外事件
     * @param name 事件名
     * @param data 事件数据
     * @returns this
     */
    Reporter.prototype.setAppEndExtraData = function (name, data) {
        var dwProcess = this.dwProcess;
        DWProcess_1$1.DWProcess.printLog('Reporter', 'setAppEndExtraData', '', { data: data, name: name });
        if (typeof name === 'string') {
            dwProcess.cache.appEndExtraEvents.push(new DWEvent_1.DWEvent(name, data, dwProcess).validate());
        }
        else {
            dwProcess.cache.appEndExtraEvents = name.map(function (_a) {
                var _b = tslib_1$4.__read(_a, 2), name = _b[0], data = _b[1];
                return new DWEvent_1.DWEvent(name, data, dwProcess).validate();
            });
        }
        return this;
    };
    /**
     * 设置统计版本号
     * @param version 版本号
     * @returns
     * @see readme
     */
    Reporter.prototype.setVersion = function (version) {
        if (version && validateString_1.validateString(version, 'dw.setVersion(version)')) {
            this.dwProcess.dwConfig.set('version', version);
            DWProcess_1$1.DWProcess.printLog('Reporter', 'setVersion', version);
        }
        return this;
    };
    /**
     * 发送PV请求, 需要 customPV 为 true
     * @returns
     * @see readme
     */
    Reporter.prototype.sendPageView = function () {
        if (this.dwProcess.dwConfig.get('customPV')) {
            this.dwProcess.sendPageView();
        }
        else {
            console.error('[dw-js-sdk] sendPageView > 请先使用dw.setCustomPV(true)开启自定义pv');
        }
        return this;
    };
    /**
     * 加入监听
     * @param name 事件名
     * @param callback 回调
     * @returns
     * @see readme
     */
    Reporter.prototype.on = function (name, callback) {
        this.dwProcess.on(name, callback);
        DWProcess_1$1.DWProcess.printLog('Reporter', 'on', '', name);
        return this;
    };
    /**
     * 适配器, 静态, 抹平不同端底层的差异
     */
    Reporter.adapters = {
        http: {},
        osInfo: {},
        storage: {}
    };
    /**
     * 固定值, 静态
     */
    Reporter.fixed = {};
    /**
     * 默认值, 静态, 默认配置
     */
    Reporter.defaults = {};
    /**
     * 默认事件绑定, 静态, 用于加载插件
     */
    Reporter.defaultBinds = [];
    return Reporter;
}());
Reporter$1.Reporter = Reporter;

var HttpAdapterWeb$1 = {};

var HttpAdapter$1 = {};

Object.defineProperty(HttpAdapter$1, "__esModule", { value: true });
HttpAdapter$1.HttpBase = HttpAdapter$1.HttpAdapter = void 0;
/**
 * 一些基本方法, 比如格式化
 */
var HttpBase = /** @class */ (function () {
    function HttpBase() {
    }
    /**
     * 格式化 json 数据
     * @param data json数据
     */
    HttpBase.prototype.formatQuery = function (data) {
        var arr = [];
        for (var name_1 in data) {
            var _data = data;
            arr.push(encodeURIComponent(name_1) + "=" + encodeURIComponent(_data[name_1]));
        }
        return arr.join('&');
    };
    /**
     * 将字符串数据转换为 json
     * @param search location.search 或不带 '?' 的 search
     */
    // protected parseQuery (search: string): object {
    //   // TODO 待定
    //   return {}
    // }
    /**
     * 转换
     * @param target 要处理的数据
     * @param transformers 处理函数
     * @returns
     */
    HttpBase.prototype.transform = function (target, transformers) {
        for (var i = 0; i < transformers.length; i++) {
            var transformer = transformers[i];
            if (typeof transformer === 'function') {
                target = transformer(target);
            }
        }
        return target;
    };
    HttpBase.prototype.getJsonpTransformer = function () {
        return function (data) {
            try {
                return JSON.parse(data.slice(data.indexOf('(') + 1, data.length - 1));
            }
            catch (e) {
                return data;
            }
        };
    };
    return HttpBase;
}());
HttpAdapter$1.HttpBase = HttpBase;
/**
 * 需要分端实现的方法
 */
var HttpAdapter = /** @class */ (function () {
    function HttpAdapter() {
    }
    return HttpAdapter;
}());
HttpAdapter$1.HttpAdapter = HttpAdapter;

Object.defineProperty(HttpAdapterWeb$1, "__esModule", { value: true });
HttpAdapterWeb$1.HttpAdapterWeb = void 0;
var tslib_1$3 = require$$0$1;
var HttpAdapter_1 = HttpAdapter$1;
var typings_1 = typings$1;
var HttpAdapterWeb = /** @class */ (function (_super) {
    tslib_1$3.__extends(HttpAdapterWeb, _super);
    function HttpAdapterWeb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'web';
        _this.send = function (url, options, callback) {
            if (options === void 0) { options = {}; }
            var _a = options.transformResponse, transformResponse = _a === void 0 ? [] : _a;
            if (options.type === typings_1.Http.Type.JSONP) {
                options.type = typings_1.Http.Type.GET;
                transformResponse.unshift(_this.getJsonpTransformer());
                // return this.jsonp(url, options, callback)
            }
            var callbackOnce = function (error, data) {
                if (!callbackOnce.called) {
                    callbackOnce.called = true;
                    callback && callback(error, data);
                }
            };
            var xhr = window.XMLHttpRequest
                ? new XMLHttpRequest()
                : new ActiveXObject('Microsoft.XMLHTTP');
            if (options.type === typings_1.Http.Type.GET && typeof options.data === 'object') {
                url += (url.includes('?') ? '&' : '?') + _this.formatQuery(options.data);
            }
            xhr.open(options.type, url);
            if (options.type === typings_1.Http.Type.POST) {
                xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            }
            for (var key in options.header) {
                xhr.setRequestHeader(key, options.header[key]);
            }
            xhr.onreadystatechange = function () {
                var statusOk = xhr.status >= 200 && xhr.status <= 207;
                if (xhr.readyState === 4 && statusOk) {
                    callbackOnce(null, xhr.responseText ? _this.transform(xhr.responseText, transformResponse) : null);
                }
                else if (xhr.readyState === 4 && !statusOk && xhr.status !== 0) {
                    callbackOnce(new Error('http error 1: status not ok'));
                }
            };
            xhr.onerror = function () {
                callbackOnce(new Error('http error 2: onerror'));
            };
            try {
                xhr.timeout = options.timeout;
                xhr.ontimeout = function () {
                    callbackOnce(new Error('http error 3: timeout'));
                };
                xhr.send(typeof options.data === 'object' ? JSON.stringify(options.data) : options.data);
            }
            catch (error) {
                callbackOnce(new Error('http error 4: catch'));
            }
            return {
                cancel: function () {
                    xhr.abort();
                }
            };
        };
        return _this;
        // /**
        //  * jsonp 解决web跨域
        //  * @param url 请求地址
        //  * @param options 配置
        //  * @param options.data 数据
        //  * @param options.timeout 过期时间
        //  * @param callback 回调
        //  */
        // private jsonp: Http.Send = (url, options = {}, callback): Http.SendReturn => {
        //   const data = options.data as object
        //   /** 获取随机数 */
        //   const random = Math.random().toString().replace('.', '')
        //   /** 基础的回调名称 */
        //   const baseCbName = '__onDWGetData__'
        //   /** 获取了随机数后的回调名称 */
        //   const callbackName = baseCbName + random
        //   /** 需要被添加到参数字符串的后缀, 动态参数会根据jsonpCallback的值返回函数名 */
        //   const suffix = 'jsonpCallback=' + baseCbName + random
        //   /** 进行数据的序列化, 随后添加上&jsonpCallback的后缀 */
        //   const query = `${this.formatQuery(data)}&${suffix}`
        //   /**
        //    * 生成script标签的url
        //    * https://dw-online.ksosoft.com/api/dynamicParam/v1/app/appKey + '?' + 序列化的参数
        //    */
        //   const requestUrl = `${url}?${query}`
        //   /** 延迟 */
        //   const timeout = options?.timeout ?? 60000
        //   /** head元素 */
        //   const target = document.head
        //   /** window */
        //   const win = window as any
        //   /** script元素 */
        //   const script = document.createElement('script')
        //   /** 超时定时器 */
        //   const timer = timeout && setTimeout(function () {
        //     cleanup()
        //     callback && callback(new Error('ReqDynamic params Timeout'))
        //   }, timeout)
        //   /** 结果处理 */
        //   const transformResponse: Http.Transformer[] = options.transformResponse || []
        //   /** 删除script，全局回调函数，超时定时器 */
        //   function cleanup () {
        //     script.parentNode && script.parentNode.removeChild(script)
        //     delete win[callbackName]
        //     clearTimeout(timer)
        //   }
        //   /** 超时取消 */
        //   function cancel () {
        //     win[callbackName] && cleanup()
        //   }
        //   /** 全局回调函数 */
        //   win[callbackName] = (data: any) => {
        //     cleanup()
        //     callback && callback(null, this.transform(data, transformResponse))
        //   }
        //   // 创建脚本
        //   // NOTE: 只需要服务端支持跨域
        //   script.crossOrigin = 'anonymous'
        //   script.src = requestUrl
        //   target.appendChild(script)
        //   return { callbackName, cancel }
        // }
    }
    return HttpAdapterWeb;
}(HttpAdapter_1.HttpBase));
HttpAdapterWeb$1.HttpAdapterWeb = HttpAdapterWeb;

var OSInfoAdapterWeb$1 = {};

var OSInfoAdapter$1 = {};

Object.defineProperty(OSInfoAdapter$1, "__esModule", { value: true });
OSInfoAdapter$1.OSInfoAdapter = void 0;
var OSInfoAdapter = /** @class */ (function () {
    function OSInfoAdapter() {
    }
    return OSInfoAdapter;
}());
OSInfoAdapter$1.OSInfoAdapter = OSInfoAdapter;

// import { cacheable } from '@/utils/cacheable'
Object.defineProperty(OSInfoAdapterWeb$1, "__esModule", { value: true });
OSInfoAdapterWeb$1.OSInfoAdapterWeb = void 0;
var tslib_1$2 = require$$0$1;
var OSInfoAdapter_1 = OSInfoAdapter$1;
var OSInfoAdapterWeb = /** @class */ (function (_super) {
    tslib_1$2.__extends(OSInfoAdapterWeb, _super);
    function OSInfoAdapterWeb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'web';
        _this.cache = {
            info: {
                isMobile: false,
                mobilePlatform: null,
                mobileOs: null,
                pcOs: null,
                brand: null,
                os: null
            }
        };
        return _this;
    }
    /**
     * 获取浏览器设备信息
     * @returns
     */
    OSInfoAdapterWeb.prototype.getBrand = function () {
        return this.cache.info.brand;
    };
    /**
     * 获取客户端操作系统
     * @returns
     */
    OSInfoAdapterWeb.prototype.getOs = function () {
        return this.cache.info.os || 'unknown';
    };
    /**
     * 获取手机和浏览器型号
     * @description 首先调用this.getBrand()
     * @description 判断浏览器是否是微信安卓版('Wechat_Android'或微信IOS版('Wechat_IOS')
     * @description 如果是, 直接返回
     * @description 如果不是, 则为浏览器 + '_' + 客户端设备
     * @returns
     */
    OSInfoAdapterWeb.prototype.getModel = function () {
        var pre = this.getBrand();
        var suf = this.cache.info.isMobile ? this.cache.info.mobilePlatform : this.cache.info.pcOs;
        return pre + "_" + suf;
    };
    /**
     * 获取屏幕的分辨率
     * @returns
     */
    OSInfoAdapterWeb.prototype.getScreen = function () {
        var width = screen.width;
        var height = screen.height;
        return width && height ? width + "*" + height : '';
    };
    OSInfoAdapterWeb.prototype.getOsVer = function () {
        return '';
    };
    OSInfoAdapterWeb.prototype.getCarrier = function () {
        return '';
    };
    OSInfoAdapterWeb.prototype.getNetwork = function () {
        return 'wifi';
    };
    /**
     * 获取系统语言
     * @returns
     */
    OSInfoAdapterWeb.prototype.getLanguage = function () {
        return navigator.language || 'zh';
    };
    OSInfoAdapterWeb.prototype.getGps = function () {
        return '';
    };
    OSInfoAdapterWeb.prototype.getPlatform = function () {
        return '';
    };
    OSInfoAdapterWeb.prototype.getCountryCode = function () {
        return 'CN';
    };
    /**
     * 获取页面标题
     * @returns
     */
    OSInfoAdapterWeb.prototype.getTitle = function () {
        var _a;
        return (_a = document.title) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * 获取页面url
     * @returns
     */
    OSInfoAdapterWeb.prototype.getUrl = function () {
        var _a;
        return (_a = location.href) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * 获取页面referrer
     * @returns
     */
    OSInfoAdapterWeb.prototype.getReferer = function () {
        var _a;
        return (_a = document.referrer) !== null && _a !== void 0 ? _a : '';
    };
    OSInfoAdapterWeb.prototype.getDeviceId = function () {
        return '';
    };
    /**
     * 准备 osInfo
     * web 端是同步的, 先不用提前准备
     * @returns
     */
    OSInfoAdapterWeb.prototype.getInfo = function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.ua, ua = _a === void 0 ? navigator.userAgent : _a;
        var isMobile = this.cache.info.isMobile = /Android|webOS|iPhone|iPod|iPad|BlackBerry|windows phone/i.test(ua);
        if (isMobile) {
            var mobilePlatformTests = [
                [/android|linux/i, 'Android', 'Android'],
                [/iphone/i, 'iPhone', 'iOS'],
                [/ipad/i, 'iPad', 'iOS'],
                [/windows/i, 'Windows Phone', 'Win mobile'],
                [null, 'unknown', 'unknown']
            ];
            for (var i = 0; i < mobilePlatformTests.length; i++) {
                var _b = tslib_1$2.__read(mobilePlatformTests[i], 3), reg = _b[0], platform = _b[1], os = _b[2];
                if (!reg || reg.test(ua)) {
                    this.cache.info.mobilePlatform = platform;
                    this.cache.info.os = this.cache.info.mobileOs = os;
                    break;
                }
            }
        }
        else {
            var platform = navigator.platform ? navigator.platform.toLowerCase() : '';
            var pcPlatformTests = [
                [/win/i, 'Win'],
                [/mac/i, 'MacOs'],
                [/linux/i, 'Linux'],
                [null, 'unknown']
            ];
            for (var i = 0; i < pcPlatformTests.length; i++) {
                var _c = tslib_1$2.__read(pcPlatformTests[i], 2), reg = _c[0], os = _c[1];
                if (!reg || reg.test(platform)) {
                    this.cache.info.os = this.cache.info.pcOs = os;
                    break;
                }
            }
        }
        var browserNameTests = [
            [/msie/i, 'IE'],
            [/rv:11.0/i, 'IE'],
            [/edge/i, 'Edge'],
            [/firefox|fxios/i, 'Firefox'],
            [/qq/i, 'QQ'],
            [/micromessenger|wechat/i, 'Wechat'],
            [/2345/i, '2345'],
            // 【IOS猎豹无法判断：Mozilla/5.0 (iPhone; CPU iPhone OS 10_1_1 like Mac OS X) AppleWebKit/602.2.14 (KHTML, like Gecko) Version/7.0 Mobile/14B100 Safari/9537.53】
            [/lbbrowser|liebao/i, 'Cheetah'],
            [/opr/i, 'Opera'],
            [/ubrowser|ucbrowser/i, 'UC'],
            [/bidubrowser|baidu/i, 'Baidu'],
            [/metasr|sogou/i, 'Sogou'],
            [/qihoobrowser|360ee|360se/i, '360'],
            [/chrome|crios/i, 'Chrome'],
            [/safari|mac/i, 'Safari'] // Safari浏览器
        ];
        for (var i = 0; i < browserNameTests.length; i++) {
            var _d = tslib_1$2.__read(browserNameTests[i], 2), reg = _d[0], browserName = _d[1];
            if (!reg || reg.test(ua)) {
                this.cache.info.brand = browserName;
                break;
            }
        }
        return Promise.resolve(this.cache.info);
    };
    return OSInfoAdapterWeb;
}(OSInfoAdapter_1.OSInfoAdapter));
OSInfoAdapterWeb$1.OSInfoAdapterWeb = OSInfoAdapterWeb;

var StorageAdapterWeb$1 = {};

/* eslint-disable no-unused-vars */
Object.defineProperty(StorageAdapterWeb$1, "__esModule", { value: true });
StorageAdapterWeb$1.StorageAdapterWeb = void 0;
var StorageAdapterWeb = /** @class */ (function () {
    function StorageAdapterWeb() {
        this.type = 'web';
    }
    StorageAdapterWeb.prototype.set = function (key, value) {
        window.localStorage.setItem(key, value);
        return Promise.resolve();
    };
    StorageAdapterWeb.prototype.get = function (key) {
        var _a;
        return Promise.resolve((_a = window.localStorage.getItem(key)) !== null && _a !== void 0 ? _a : '');
    };
    StorageAdapterWeb.prototype.rm = function (key) {
        window.localStorage.removeItem(key);
        return Promise.resolve();
    };
    return StorageAdapterWeb;
}());
StorageAdapterWeb$1.StorageAdapterWeb = StorageAdapterWeb;

var web = {};

var aes$1 = {};

var aes = {exports: {}};

var core = {exports: {}};

var empty = {};

var empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(empty$1);

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory();
	}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined$1) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof global !== 'undefined' && global.crypto) {
	        crypto = global.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && typeof commonjsRequire === 'function') {
	        try {
	            crypto = require$$0;
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined$1) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
}(core));

var encBase64 = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));
}(encBase64));

var md5 = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));
}(md5));

var evpkdf = {exports: {}};

var sha1 = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));
}(sha1));

var hmac = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));
}(hmac));

(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core.exports, sha1.exports, hmac.exports);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            var block;

	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));
}(evpkdf));

var cipherCore = {exports: {}};

(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core.exports, evpkdf.exports);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined$1) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            var block;

	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined$1;
	            } else {
	                block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            var modeCreator;

	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            var finalProcessedBlocks;

	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            var wordArray;

	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            var salt;

	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));
}(cipherCore));

(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core.exports, encBase64.exports, md5.exports, evpkdf.exports, cipherCore.exports);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            var t;

	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));
}(aes));

var encUtf8 = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));
}(encUtf8));

var padPkcs7 = {exports: {}};

(function (module, exports) {
(function (root, factory, undef) {
	{
		// CommonJS
		module.exports = factory(core.exports, cipherCore.exports);
	}
}(this, function (CryptoJS) {

	return CryptoJS.pad.Pkcs7;

}));
}(padPkcs7));

Object.defineProperty(aes$1, "__esModule", { value: true });
aes$1.aesEncrypt = void 0;
var tslib_1$1 = require$$0$1;
var aes_js_1 = tslib_1$1.__importDefault(aes.exports);
var enc_utf8_js_1 = tslib_1$1.__importDefault(encUtf8.exports);
var pad_pkcs7_js_1 = tslib_1$1.__importDefault(padPkcs7.exports);
/**
 * aes加密,返回值为base64格式
 * MODE:CBC（默认，无需配置）
 * padding:Pkcs7（pkcs5等同于pkcs7）
 * @param key 秘钥，base64格式
 * @param content 要加密的内容，base64格式
 * @returns
 */
function aesEncrypt(key, content) {
    var contentString = typeof content === 'object'
        ? content = JSON.stringify(content)
        : content;
    // 这些数据必须是 CryptoJs 需要的 WordArray 格式
    var iv = enc_utf8_js_1.default.parse('');
    var keyParsed = enc_utf8_js_1.default.parse(key);
    content = enc_utf8_js_1.default.parse(content);
    return aes_js_1.default.encrypt(contentString, keyParsed, {
        iv: iv,
        // mode:CBC,
        padding: pad_pkcs7_js_1.default
    }).toString();
}
aes$1.aesEncrypt = aesEncrypt;
/**
 * 这里是发送前的通用加密, 对 eventBody 进行加密
 */
var pkg$2 = {
    install: function (Reporter, options) {
        Reporter.appendPreBind({
            name: 'plugin-encrypt-aes',
            event: 'event-body-encrypt',
            callback: function (_a) {
                var dwEvent = _a.dwEvent, eventBody = _a.eventBody, dwProcess = _a.dwProcess;
                var dwConfig = dwProcess.dwConfig;
                var config = dwConfig.getAll();
                if ((config.dbg || config.debugMode) && config.noEncrypted) {
                    dwEvent.eventBodyEncrypted = JSON.stringify(eventBody);
                    return;
                }
                if (dwEvent.isPostStopped()) {
                    return;
                }
                dwEvent.eventBodyEncrypted = aesEncrypt(options.aesKey, eventBody);
            }
        });
    }
};
aes$1.default = pkg$2;

var rsa = {};

/* eslint-disable */
/**
说明：此rsa库仅支持加密，由jsbn.js + prng4.js + rng.js + rsa.js + base64.js构成
地址：http://www-cs-students.stanford.edu/~tjw/jsbn/
导出变量：RSAKey
使用方式：
let key='your public'; //公钥
let content='need encrypted string'; //要加密的内容，如果是object使用JOSN.stringify(content)转字符串
const encrypt = new RSAKey();
encrypt.setPublic(key,'10001'); //'10001'~openssl生成秘钥时的e的值(0x10001)，一般为10001
content = encrypt.encrypt(content);
*/
Object.defineProperty(rsa, "__esModule", { value: true });
rsa.linebrk = rsa.hex2b64 = void 0;
// 1. jsbn.js
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
// Bits per digit
// @ts-nocheck
var dbits;
// (public) Constructor
function BigInteger(a, b, c) {
    if (a != null)
        if ('number' == typeof a)
            this.fromNumber(a, b, c);
        else if (b == null && 'string' != typeof a)
            this.fromString(a, 256);
        else
            this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while (--n >= 0) {
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff;
    var xh = x >> 15;
    while (--n >= 0) {
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff;
    var xh = x >> 14;
    while (--n >= 0) {
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
if (navigator.appName == 'Microsoft Internet Explorer') {
    BigInteger.prototype.am = am2;
    dbits = 30;
}
else if (navigator.appName != 'Netscape') {
    BigInteger.prototype.am = am1;
    dbits = 26;
}
else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var BI_RC = new Array();
var rr;
var vv;
rr = '0'.charCodeAt(0);
for (vv = 0; vv <= 9; ++vv)
    BI_RC[rr++] = vv;
rr = 'a'.charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
    BI_RC[rr++] = vv;
rr = 'A'.charCodeAt(0);
for (vv = 10; vv < 36; ++vv)
    BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for (var i = this.t - 1; i >= 0; --i)
        r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0)
        this[0] = x;
    else if (x < -1)
        this[0] = x + this.DV;
    else
        this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16)
        k = 4;
    else if (b == 8)
        k = 3;
    else if (b == 256)
        k = 8;
    // byte array
    else if (b == 2)
        k = 1;
    else if (b == 32)
        k = 5;
    else if (b == 4)
        k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length;
    var mi = false;
    var sh = 0;
    while (--i >= 0) {
        var x = k == 8 ? s[i] & 0xff : intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == '-')
                mi = true;
            continue;
        }
        mi = false;
        if (sh == 0)
            this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
            this[this.t++] = x >> (this.DB - sh);
        }
        else
            this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB)
            sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0)
            this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
    }
    this.clamp();
    if (mi)
        BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while (this.t > 0 && this[this.t - 1] == c)
        --this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0)
        return '-' + this.negate().toString(b);
    var k;
    if (b == 16)
        k = 4;
    else if (b == 8)
        k = 3;
    else if (b == 2)
        k = 1;
    else if (b == 32)
        k = 5;
    else if (b == 4)
        k = 2;
    else
        return this.toRadix(b);
    var km = (1 << k) - 1;
    var d;
    var m = false;
    var r = '';
    var i = this.t;
    var p = this.DB - ((i * this.DB) % k);
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while (i >= 0) {
            if (p < k) {
                d = (this[i] & ((1 << p) - 1)) << (k - p);
                d |= this[--i] >> (p += this.DB - k);
            }
            else {
                d = (this[i] >> (p -= k)) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0)
                m = true;
            if (m)
                r += int2char(d);
        }
    }
    return m ? r : '0';
}
// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0)
        return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0)
        return this.s < 0 ? -r : r;
    while (--i >= 0)
        if ((r = this[i] - a[i]) != 0)
            return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0)
        return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for (i = this.t - 1; i >= 0; --i)
        r[i + n] = this[i];
    for (i = n - 1; i >= 0; --i)
        r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for (var i = n; i < this.t; ++i)
        r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB);
    var c = (this.s << bs) & this.DM;
    var i;
    for (i = this.t - 1; i >= 0; --i) {
        r[i + ds + 1] = (this[i] >> cbs) | c;
        c = (this[i] & bm) << bs;
    }
    for (i = ds - 1; i >= 0; --i)
        r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for (var i = ds + 1; i < this.t; ++i) {
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0)
        r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0;
    var c = 0;
    var m = Math.min(a.t, this.t);
    while (i < m) {
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while (i < this.t) {
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    }
    else {
        c += this.s;
        while (i < a.t) {
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1)
        r[i++] = this.DV + c;
    else if (c > 0)
        r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs();
    var y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while (--i >= 0)
        r[i] = 0;
    for (i = 0; i < y.t; ++i)
        r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s)
        BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = (r.t = 2 * x.t);
    while (--i >= 0)
        r[i] = 0;
    for (i = 0; i < x.t - 1; ++i) {
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0)
        r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0)
        return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null)
            q.fromInt(0);
        if (r != null)
            this.copyTo(r);
        return;
    }
    if (r == null)
        r = nbi();
    var y = nbi();
    var ts = this.s;
    var ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    }
    else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0)
        return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt;
    var d2 = (1 << this.F1) / yt;
    var e = 1 << this.F2;
    var i = r.t;
    var j = i - ys;
    var t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while (y.t < ys)
        y[y.t++] = 0;
    while (--j >= 0) {
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while (r[i] < --qd)
                r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms)
            BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0)
        r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0)
        BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0)
        a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function Classic(m) {
    this.m = m;
}
function cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0)
        return x.mod(this.m);
    else
        return x;
}
function cRevert(x) {
    return x;
}
function cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1)
        return 0;
    var x = this[0];
    if ((x & 1) == 0)
        return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
    y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
    y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = (y * (2 - ((x * y) % this.DV))) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << (m.DB - 15)) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0)
        this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while (x.t <= this.mt2 // pad x so am has enough room later
    )
        x[x.t++] = 0;
    for (var i = 0; i < this.m.t; ++i) {
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while (x[j] >= x.DV) {
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0)
        x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (protected) true iff this is even
function bnpIsEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function bnpExp(e, z) {
    if (e > 0xffffffff || e < 1)
        return BigInteger.ONE;
    var r = nbi();
    var r2 = nbi();
    var g = z.convert(this);
    var i = nbits(e) - 1;
    g.copyTo(r);
    while (--i >= 0) {
        z.sqrTo(r, r2);
        if ((e & (1 << i)) > 0)
            z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven())
        z = new Classic(m);
    else
        z = new Montgomery(m);
    return this.exp(e, z);
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.isEven = bnpIsEven;
BigInteger.prototype.exp = bnpExp;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.modPowInt = bnModPowInt;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);
// 2. prng4.js - uses Arcfour as a PRNG
function Arcfour() {
    this.i = 0;
    this.j = 0;
    this.S = new Array();
}
// Initialize arcfour context from key, an array of ints, each from [0..255]
function ARC4init(key) {
    var i;
    var j;
    var t;
    for (i = 0; i < 256; ++i)
        this.S[i] = i;
    j = 0;
    for (i = 0; i < 256; ++i) {
        j = (j + this.S[i] + key[i % key.length]) & 255;
        t = this.S[i];
        this.S[i] = this.S[j];
        this.S[j] = t;
    }
    this.i = 0;
    this.j = 0;
}
function ARC4next() {
    var t;
    this.i = (this.i + 1) & 255;
    this.j = (this.j + this.S[this.i]) & 255;
    t = this.S[this.i];
    this.S[this.i] = this.S[this.j];
    this.S[this.j] = t;
    return this.S[(t + this.S[this.i]) & 255];
}
Arcfour.prototype.init = ARC4init;
Arcfour.prototype.next = ARC4next;
// Plug in your RNG constructor here
function prng_newstate() {
    return new Arcfour();
}
// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize = 256;
// 3. rng.js
// Random number generator - requires a PRNG backend, e.g. prng4.js
// For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.
var rng_state;
var rng_pool;
var rng_pptr;
// Mix in a 32-bit integer into the pool
function rng_seed_int(x) {
    rng_pool[rng_pptr++] ^= x & 255;
    rng_pool[rng_pptr++] ^= (x >> 8) & 255;
    rng_pool[rng_pptr++] ^= (x >> 16) & 255;
    rng_pool[rng_pptr++] ^= (x >> 24) & 255;
    if (rng_pptr >= rng_psize)
        rng_pptr -= rng_psize;
}
// Mix in the current time (w/milliseconds) into the pool
function rng_seed_time() {
    rng_seed_int(new Date().getTime());
}
// Initialize the pool with junk if needed.
if (rng_pool == null) {
    rng_pool = new Array();
    rng_pptr = 0;
    var t = void 0;
    if (window.crypto && window.crypto.getRandomValues) {
        // Use webcrypto if available
        var ua = new Uint8Array(32);
        window.crypto.getRandomValues(ua);
        for (t = 0; t < 32; ++t)
            rng_pool[rng_pptr++] = ua[t];
    }
    if (navigator.appName == 'Netscape' &&
        navigator.appVersion < '5' &&
        window.crypto &&
        window.crypto.random) {
        // Extract entropy (256 bits) from NS4 RNG if available
        var z = window.crypto.random(32);
        for (t = 0; t < z.length; ++t)
            rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
    }
    while (rng_pptr < rng_psize) {
        // extract some randomness from Math.random()
        t = Math.floor(65536 * Math.random());
        rng_pool[rng_pptr++] = t >>> 8;
        rng_pool[rng_pptr++] = t & 255;
    }
    rng_pptr = 0;
    rng_seed_time();
    // rng_seed_int(window.screenX);
    // rng_seed_int(window.screenY);
}
function rng_get_byte() {
    if (rng_state == null) {
        rng_seed_time();
        rng_state = prng_newstate();
        rng_state.init(rng_pool);
        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
            rng_pool[rng_pptr] = 0;
        rng_pptr = 0;
        // rng_pool = null;
    }
    // TODO: allow reseeding after first request
    return rng_state.next();
}
function rng_get_bytes(ba) {
    var i;
    for (i = 0; i < ba.length; ++i)
        ba[i] = rng_get_byte();
}
function SecureRandom() { }
SecureRandom.prototype.nextBytes = rng_get_bytes;
// 4. rsa.js
// Depends on jsbn.js and rng.js
// Version 1.1: support utf-8 encoding in pkcs1pad2
// convert a (hex) string to a bignum object
function parseBigInt(str, r) {
    return new BigInteger(str, r);
}
// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
    if (n < s.length + 11) {
        // TODO: fix for utf-8
        alert('Message too long for RSA');
        return null;
    }
    var ba = new Array();
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        var c = s.charCodeAt(i--);
        if (c < 128) {
            // encode using utf-8
            ba[--n] = c;
        }
        else if (c > 127 && c < 2048) {
            ba[--n] = (c & 63) | 128;
            ba[--n] = (c >> 6) | 192;
        }
        else {
            ba[--n] = (c & 63) | 128;
            ba[--n] = ((c >> 6) & 63) | 128;
            ba[--n] = (c >> 12) | 224;
        }
    }
    ba[--n] = 0;
    var rng = new SecureRandom();
    var x = new Array();
    while (n > 2) {
        // random non-zero pad
        x[0] = 0;
        while (x[0] == 0)
            rng.nextBytes(x);
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new BigInteger(ba);
}
// "empty" RSA key constructor
function RSAKey() {
    this.n = null;
    this.e = 0;
    this.d = null;
    this.p = null;
    this.q = null;
    this.dmp1 = null;
    this.dmq1 = null;
    this.coeff = null;
}
// Set the public key fields N and e from hex strings
function RSASetPublic(N, E) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
        this.n = parseBigInt(N, 16);
        this.e = parseInt(E, 16);
    }
    else
        alert('Invalid RSA public key');
}
// Perform raw public operation on "x": return x^e (mod n)
function RSADoPublic(x) {
    return x.modPowInt(this.e, this.n);
}
// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
function RSAEncrypt(text) {
    var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
    if (m == null)
        return null;
    var c = this.doPublic(m);
    if (c == null)
        return null;
    var h = c.toString(16);
    if ((h.length & 1) == 0)
        return h;
    else
        return '0' + h;
}
// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
// function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
// }
// protected
RSAKey.prototype.doPublic = RSADoPublic;
// public
RSAKey.prototype.setPublic = RSASetPublic;
RSAKey.prototype.encrypt = RSAEncrypt;
// RSAKey.prototype.encrypt_b64 = RSAEncryptB64;
// 5. base64.js
var b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var b64padchar = '=';
function hex2b64(h) {
    var i;
    var c;
    var ret = '';
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    }
    else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0)
        ret += b64padchar;
    return ret;
}
rsa.hex2b64 = hex2b64;
// 去掉\n
function linebrk(s, n) {
    var ret = '';
    var i = 0;
    while (i + n < s.length) {
        // ret += s.substring(i, i + n) + "\n";
        ret += s.substring(i, i + n);
        i += n;
    }
    return ret + s.substring(i, s.length);
}
rsa.linebrk = linebrk;
rsa.default = RSAKey;

var generateRandomString$1 = {};

Object.defineProperty(generateRandomString$1, "__esModule", { value: true });
generateRandomString$1.generateRandomString = void 0;
/**
   * 生成随机字母组成的字符串
   * @param {number} length 生成的字符串长度
   */
function generateRandomString(length) {
    if (length === void 0) { length = 32; }
    var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var max = letters.length;
    var str = '';
    for (var i = 0; i < length; i++) {
        str += letters.charAt(Math.floor(Math.random() * max));
    }
    return str;
}
generateRandomString$1.generateRandomString = generateRandomString;

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.webEncrypt = exports.rsaEncrypt = exports.aesEncrypt = void 0;
var tslib_1 = require$$0$1;
var aes_1 = tslib_1.__importStar(aes$1);
var rsa_1 = tslib_1.__importStar(rsa);
var generateRandomString_1 = generateRandomString$1;
var aes_2 = aes$1;
Object.defineProperty(exports, "aesEncrypt", { enumerable: true, get: function () { return aes_2.aesEncrypt; } });
/**
 * rsa加密，并转为base64返回
 * @param key Modulus (hex)，并非公钥，它用来生成公钥
 * @param content 要加密的内容，要求为字符串，如果包含汉字，需测试是否乱码（前端测试无问题）
 * @returns a base64 string
 */
function rsaEncrypt(key, content) {
    if (rsa_1.default && rsa_1.linebrk && rsa_1.hex2b64) {
        var retryCount_1 = 0;
        var todo_1 = function (key, content) {
            var encrypt = new rsa_1.default();
            encrypt.setPublic(key, '10001');
            var encrypted = encrypt.encrypt(content);
            encrypted = rsa_1.linebrk(rsa_1.hex2b64(encrypted), 64);
            if (encrypted.length !== 344 && retryCount_1 < 10) {
                retryCount_1++;
                encrypted = todo_1(key, content);
            }
            retryCount_1 = 0;
            return encrypted;
        };
        return todo_1(key, content);
    }
    else {
        return content;
    }
}
exports.rsaEncrypt = rsaEncrypt;
/**
 * 给 http 参数 JSON 对象中指定的字段加密 (aes+rsa),返回一个新对象(浅复制)和加密后的 aesKey
 * @param eventData 要加密的数据
 * @param events 要加密的事件名
 * @param rsaKey rsa密钥
 * @returns
 */
function webEncrypt(eventData, events, rsaKey) {
    var encryptedData = Object.assign({}, eventData);
    var aesKey = generateRandomString_1.generateRandomString(16); // // 随机秘钥
    for (var i = 0, l = events.length; i < l; i++) {
        var key = events[i];
        var val = encryptedData[key];
        // aes加密
        if (val != null) {
            encryptedData[key] = aes_1.aesEncrypt(aesKey, String(val));
        }
    }
    var encryptedAesKey = rsaEncrypt(rsaKey, aesKey);
    return {
        encryptedData: encryptedData,
        encryptedKey: encryptedAesKey
    };
}
exports.webEncrypt = webEncrypt;
var pkg = {
    install: function (Reporter, options) {
        Reporter.appendPreBind({
            name: 'plugin-encrypt-web',
            event: 'event-data-encrypt',
            callback: function (_a) {
                var _b, _c, _d;
                var dwEvent = _a.dwEvent, dwProcess = _a.dwProcess;
                dwEvent.validate();
                var dwConfig = dwProcess.dwConfig;
                var config = dwConfig.getAll();
                if ((config.dbg || config.debugMode) && config.noEncrypted) {
                    dwEvent.dataEncrypted = dwEvent.data;
                    return;
                }
                var events;
                var data = (_d = (_c = (_b = dwProcess.dynamicData) === null || _b === void 0 ? void 0 : _b.events) === null || _c === void 0 ? void 0 : _c.data) !== null && _d !== void 0 ? _d : [];
                if (dwEvent.name === '_page_view') {
                    // 默认加密项
                    events = ['title', 'url', 'refer'];
                }
                else {
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        // 找到对应的事件
                        if (item.name === dwEvent.name) {
                            // 如果有需要加密的项
                            if (item.encryptAttrs) {
                                events = item.encryptAttrs;
                            }
                            break;
                        }
                    }
                }
                if (events && dwEvent.data) {
                    var _e = webEncrypt(dwEvent.data, events, options.rsaKey), encryptedData = _e.encryptedData, encryptedKey = _e.encryptedKey;
                    if (encryptedKey) {
                        var encryptInfo = {
                            _encrypted_key: encryptedKey,
                            _encrypted_version: '20160113',
                            _encrypted_fields: events.join(',')
                        };
                        Object.assign(encryptedData, encryptInfo);
                    }
                    dwEvent.dataEncrypted = encryptedData;
                }
            }
        });
        // 注册 event-body-encrypt 事件
        aes_1.default.install(Reporter, {
            aesKey: options.aesKey
        });
    }
};
exports.default = pkg;
}(web));

var sendInLimitConnect = {};

// 用于控制链接数量的插件
Object.defineProperty(sendInLimitConnect, "__esModule", { value: true });
var pkg$1 = {
    install: function (Reporter, options) {
        /**
         * 链接数量
         * 在这里定义, 统一所有实例的请求
         */
        var connectCount = 0;
        /**
         * 最大链接数量
         */
        var connectLimit = options.max;
        Reporter.appendPreBind({
            name: 'send-in-limit-connect-before-event',
            event: 'before-event-send',
            callback: function (_a) {
                var dwEvent = _a.dwEvent;
                if (dwEvent.isPostStopped()) {
                    return;
                }
                if (connectCount >= connectLimit) {
                    dwEvent
                        .saveWait()
                        .stopPost();
                }
                else {
                    connectCount++;
                }
            }
        });
        Reporter.appendPreBind({
            name: 'send-in-limit-connect-after-event',
            event: 'after-event-send',
            callback: function (_a) {
                _a.dwProcess;
                if (connectCount > 0) {
                    // FIXME 不知道会不会有其他行为导致这个回调没有被执行
                    connectCount--;
                }
            }
        });
        Reporter.appendPreBind({
            name: 'send-in-limit-connect-before-dynamic',
            event: 'before-dynamic-send',
            callback: function (_a) {
                var dwDynamic = _a.dwDynamic;
                if (dwDynamic.isPostStopped()) {
                    return;
                }
                if (connectCount >= connectLimit) {
                    dwDynamic.retry();
                    dwDynamic.stopPost();
                }
                else {
                    connectCount++;
                    // console.log(connectCount)
                }
            }
        });
        Reporter.appendPreBind({
            name: 'send-in-limit-connect-after-dynamic',
            event: 'after-dynamic-send',
            callback: function () {
                if (connectCount > 0) {
                    // FIXME 不知道会不会有其他行为导致这个回调没有被执行
                    connectCount--;
                }
            }
        });
    }
};
sendInLimitConnect.default = pkg$1;

var sendInThrottle = {};

// 用于节流上传的插件
Object.defineProperty(sendInThrottle, "__esModule", { value: true });
var pkg = {
    install: function (Reporter, options) {
        var _a = options !== null && options !== void 0 ? options : {}, _b = _a.debounce, debounce = _b === void 0 ? 0 : _b, _c = _a.throttle, throttle = _c === void 0 ? 0 : _c, _d = _a.ignoreEventNames, ignoreEventNames = _d === void 0 ? [] : _d;
        Reporter.appendPreBind({
            name: 'plugin-send-in-throttle',
            event: 'before-event-send',
            callback: function (_a) {
                var dwEvent = _a.dwEvent, dwProcess = _a.dwProcess;
                // 各自实例
                if (!dwProcess.cache.others.throttle) {
                    dwProcess.cache.others.throttle = {
                        first: false,
                        debounceTimer: null,
                        throttleTimer: null
                    };
                }
                var dwService = dwProcess.dwService, _cache = dwProcess.cache.others.throttle;
                var cache = _cache;
                if (dwEvent.isPostStopped()) {
                    return;
                }
                if (dwEvent.from === 'wait') {
                    return;
                }
                if (ignoreEventNames.includes(dwEvent.name)) {
                    return;
                }
                var send = function () {
                    cache.first = false;
                    clearTimeout(cache.debounceTimer);
                    clearTimeout(cache.throttleTimer);
                    cache.debounceTimer = null;
                    cache.throttleTimer = null;
                    dwService.sendWaitEvents(dwProcess);
                };
                if (debounce > 0) {
                    dwEvent
                        .saveWait()
                        .stopPost();
                    clearTimeout(cache.debounceTimer);
                    cache.debounceTimer = setTimeout(send, debounce);
                }
                if (throttle > 0) {
                    if (!cache.first) {
                        cache.first = true;
                        clearTimeout(cache.throttleTimer);
                        cache.throttleTimer = setTimeout(send, throttle);
                    }
                }
            }
        });
    }
};
sendInThrottle.default = pkg;

Object.defineProperty(WebReporter$1, "__esModule", { value: true });
var WebReporter_2 = WebReporter$1.WebReporter = void 0;
var tslib_1 = require$$0$1;
var base_64_1 = tslib_1.__importDefault(base64.exports);
var utf8_1 = tslib_1.__importDefault(utf8);
var Reporter_1 = Reporter$1;
var HttpAdapterWeb_1 = HttpAdapterWeb$1;
var OSInfoAdapterWeb_1 = OSInfoAdapterWeb$1;
var StorageAdapterWeb_1 = StorageAdapterWeb$1;
// import { StorageAdapterWebIndexDB } from '@/adapter/StorageAdapter/StorageAdapterWebIndexDB'
// import { setDailyTask } from '@/utils/setDailyTask'
var web_1 = tslib_1.__importDefault(web);
// import PluginParseUrl, { PluginParseUrlOptions } from '@/plugins/parseUrl'
var sendInLimitConnect_1 = tslib_1.__importDefault(sendInLimitConnect);
var sendInThrottle_1 = tslib_1.__importDefault(sendInThrottle);
var DWProcess_1 = DWProcess$1;
// 设置适配器
Reporter_1.Reporter.adapters.http = new HttpAdapterWeb_1.HttpAdapterWeb();
Reporter_1.Reporter.adapters.osInfo = new OSInfoAdapterWeb_1.OSInfoAdapterWeb();
// Reporter.adapters.storage = window.indexedDB ? new StorageAdapterWebIndexDB() : new StorageAdapterWeb()
Reporter_1.Reporter.adapters.storage = new StorageAdapterWeb_1.StorageAdapterWeb();
// 设置全局配置项
Reporter_1.Reporter.defaults = {
    dynamicUrl: 'https://dw-online.ksosoft.com',
    sendUrl: '(https://shuc-js.ksord.com/bat/js/cors)',
    debugUrl: '(https://dw-collect-debug.ksord.com)',
    handleAppEnd: function (dwProcess, options) {
        if (options.fresh) {
            return;
        }
        var dwStorage = dwProcess.dwStorage;
        // 要做一个同步的方法
        var send = function () {
            if (typeof navigator.sendBeacon === 'function') {
                var dwEvent = dwProcess.generateAppEndEvent();
                if (typeof navigator.onLine === 'boolean' && !navigator.onLine) {
                    // 离线状态
                    // @ts-ignore
                    dwEvent.saveFail();
                    dwStorage.fail.sync();
                    return;
                }
                var dataString = base_64_1.default.encode(utf8_1.default.encode(JSON.stringify(dwEvent.eventBody)));
                var blob = new Blob([dataString], {
                    type: 'application/x-www-form-urlencoded'
                });
                var url = dwEvent.urlsParsed[0];
                if (dwProcess.isDebug()) {
                    console.log('beacon url', url);
                    console.log('beacon body', JSON.stringify(dwEvent.eventBody));
                }
                navigator.sendBeacon(typeof url === 'string' ? url : url[0], blob);
            }
            else {
                console.log('[dw-js-sdk] "sendBeacon" is not supported, use normal method to send app_end.');
                dwProcess.sendAppEnd();
            }
        };
        if ('onbeforeunload' in window) {
            window.addEventListener('beforeunload', send, false);
        }
        else {
            // @ts-ignore
            window.addEventListener('pagehide', send, false);
        }
    }
};
// 加密插件
Reporter_1.Reporter.use(web_1.default, {
    aesKey: "ZctYg7JjXcPySXxw",
    rsaKey: "8762DEC337D703A5841A8090180350203AC0C2809A864BF6CA31979FCD7AA3D1BFA38CF8B243878984CBC9B83496CBAC87B448F74EA7550D579BD5820EFD17F5D22D0665AB114FB6EBA74261B4EB040828FBCA7CF95EF0D56BBFD9C67E5941AFFB34DE4C6FA2E737C16D9C703A43D90F65B40E7F3E44C1165C1ED3BD10BC449421863174E8EFA3CA618E0DEE7EDD65F07AAE0586AB1702B1D95F29F3BA447AD744E9B37ACB3F510D068A2D6BDBE4F0689B26A9AFCF66219160E7CF802D2F1A56503F462693B62747AD4163DBC1222687D154C53C03BBB5D2DE9ABC2DE6907E3B26E45C4FCA63F28258C4D07D3E152AE51F80A0DA7B77A3E1D0EFE72A988B57F9"
});
// url解析插件
// Reporter.use<PluginParseUrlOptions>(PluginParseUrl, {})
// 1. 检查是否在节流等待中
Reporter_1.Reporter.use(sendInThrottle_1.default, {
    debounce: parseInt("300"),
    throttle: parseInt("5000"),
    ignoreEventNames: ['_app_end']
});
// 3. 检查是否超过最大连接数量
Reporter_1.Reporter.use(sendInLimitConnect_1.default, {
    max: 3
});
var WebReporter = /** @class */ (function (_super) {
    tslib_1.__extends(WebReporter, _super);
    function WebReporter(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        _this.options = options;
        var now = new Date();
        _this._lastFreshDate = [now.getFullYear(), now.getMonth() + 1, now.getDate()];
        return _this;
    }
    /**
     * 创建一个新的 Reporter
     * @param appKey appKey
     * @param options options
     * @returns
     * @see readme
     */
    WebReporter.prototype.createReporter = function (appKey, options) {
        if (!appKey) {
            throw Error('createReporter requires param appKey.');
        }
        return new WebReporter(options).setAppKey(appKey);
    };
    /**
     * 设置每日刷新
     * @param time 刷新时间 hh:mm
     * @returns this
     * @tip returns Promise<{ clear: () => void }> clear 方法为清空定时器, 停止任务
     * @description 每日刷新执行逻辑:
     * 发送 app_end => 执行 init
     * 重新获取动参, 发送 app_start, 发送 page_view
     * 不会再次注册 app_end
     */
    WebReporter.prototype.setDailyFresh = function (time) {
        var _this = this;
        if (time === void 0) { time = '00:15'; }
        var match = time.match(/(\d?\d):(\d?\d)/);
        var errorMessage = '请设置正确的时间格式 hh:mm';
        if (!match) {
            throw Error(errorMessage);
        }
        var hour = parseInt(match[1]);
        var minute = parseInt(match[2]);
        if (hour > 24 || minute > 60) {
            throw Error(errorMessage);
        }
        var serviceDate = this.dwProcess.getRemoteDate();
        DWProcess_1.DWProcess.printLog('WebReporter', 'setDailyFresh', time);
        if (serviceDate) {
            var targetDate = new Date(serviceDate);
            var randomLength = parseInt("21600000 # 6小时"); // 6小时
            // const randomLength = 1 * 30 * 1000 // test 30秒
            // 超过 18:00 的提示
            // if (hour > 18 || (hour === 18 && minute > 0)) {
            //   console.group('[dw-js-sdk] warn')
            //   console.warn('建议设置 00:00-18:00 范围内的时间')
            //   console.log('因为为了避免集中上报, sdk会在设置时间后的6小时内随机一个时间进行刷新')
            //   console.log('如果随机后的时间超过 18:00, ')
            // }
            targetDate.setHours(hour);
            targetDate.setMinutes(minute);
            targetDate.setSeconds(0, 0);
            // 添加1个的随机时间
            targetDate.setTime(targetDate.getTime() + Math.random() * randomLength);
            // 与当前服务器时间做比较
            var sub = targetDate.getTime() - serviceDate.getTime();
            var dailyInterval_1 = 24 * 60 * 60 * 1000; // 一天
            // const dailyInterval = 1 * 60 * 1000 // test 1分钟
            var firstInterval = sub > 0 ? sub : sub + dailyInterval_1;
            // test
            // console.log(`服务器时间: ${serviceDate.toLocaleString()}`)
            // console.log(`定时任务时间: ${targetDate.toLocaleString()}`)
            // console.log('firstInterval', firstInterval)
            // 每天定时循环
            var loop_1 = function () {
                // DONE: 判断是否是同一天 (之前发送 appStart 事件的时间和 targetDate 的比较)
                _this.dwProcess.refresh();
                _this._dailyRefreshTimer = setTimeout(loop_1, dailyInterval_1);
            };
            // 开启当天定时
            clearTimeout(this._dailyRefreshTimer);
            this._dailyRefreshTimer = setTimeout(loop_1, firstInterval);
        }
        else {
            // 服务器时间未知时, 不设置自动刷新, 一分钟后再尝试自动刷新
            setTimeout(function () { return _this.setDailyFresh(time); }, 60 * 1000);
        }
        return this;
    };
    /**
     * 手动刷新报活，当天不会重复上报
     * @returns void
     */
    WebReporter.prototype.forceFresh = function () {
        var now = new Date();
        var currentDate = [now.getFullYear(), now.getMonth() + 1, now.getDate()];
        var reduceFn = function (prev, curr, index) {
            var current = curr;
            if (index === 1) {
                // 月份 x 100 增加优先级
                current = current * 100;
            }
            return prev + current;
        };
        var sub = currentDate.reduce(reduceFn) - this._lastFreshDate.reduce(reduceFn);
        if (sub <= 0) {
            DWProcess_1.DWProcess.printLog('WebReporter', 'forceFresh', 'fail: same date', { currentDate: currentDate.join('-'), lastFreshDate: this._lastFreshDate.join('-') });
            return;
        }
        DWProcess_1.DWProcess.printLog('WebReporter', 'forceFresh', 'success', { currentDate: currentDate.join('-'), lastFreshDate: this._lastFreshDate.join('-') }, true);
        this.dwProcess.refresh(true);
        this._lastFreshDate = currentDate;
    };
    return WebReporter;
}(Reporter_1.Reporter));
WebReporter_2 = WebReporter$1.WebReporter = WebReporter;
var _default = WebReporter$1.default = WebReporter;

export { WebReporter_2 as WebReporter, _default as default };
